/* eslint import/prefer-default-export: 0 */

import { employmentActivityTypes, employmentMilitaryBranchValues } from 'constants/enums/employmentOptions';
import { disciplineSentenceOptions } from 'constants/enums/militaryOptions';

export const history = {
  pvq: {
    selfEmploymentTitles: {
      main: 'Who can verify your self-employment? (Unless there is no one else who can verify this self - employment, please do not list yourself, your spouse; partner from a civil union, domestic partnership, or common law marriage; person you are in a committed, spouse - like relationship with; or any relative as a verifier.) ',
      emails: 'What is their email address? (You may list more than one.)',
      emailsAppend: 'Do you have another email address to add?',
      emailsEmailFieldTitle: 'Email Address',
      telephones: 'What is their phone number? (You may list more than one.)',
      telephonesAppend: 'Do you have another phone number to add?',
      details: 'Verifer Details',
      addressLabel: 'Does this person currently live or work in the U.S.? ',
      domestic: 'What is their current address?',
      foreign: 'Where are they currently located? ',
    },
    unemploymentTitles: {
      main: 'Who can verify your activities while unemployed and your means of support during that time? (Unless there is no one else who can verify the unemployment, please do not list yourself, your spouse; partner from a civil union, domestic partnership, or common law marriage; person you are in a committed, spouse- like relationship with; or any relative as a verifier.) ',
      when: 'When were you unemployed?',
      emails: 'What is their email address? (You may list more than one.)',
      emailsAppend: 'Do you have another email address to add?',
      emailsEmailFieldTitle: 'Email Address',
      telephones: 'What is their phone number? (You may list more than one.)',
      telephonesAppend: 'Do you have another phone number to add?',
      details: 'Verifer Details',
      addressLabel: 'Does this person currently live or work in the U.S.? ',
      domestic: 'What is their current address?',
      foreign: 'Where are they currently located?',
    },
    intro: {
      title: 'Your history',
      body:
        'You will be asked questions about your history and to provide details if necessary. This section includes where you have lived, where you have worked, and where you went to school.',
    },
    tour: {
      para: 'Take a guided tour through the section',
    },
    review: {
      title: 'Full section view',
      para: 'View all the sections associated with your history at once',
      button: 'Show me the full section',
    },
    section: {
      name: 'Your history',
    },
    subsection: {
      intro: 'Introduction',
      residence: 'Where you have lived',
      employment: 'Employment activities',
      education: 'Where you went to school',
      federal: 'Former federal service',
      review: 'Review',
    },
    destination: {
      intro: 'History intro',
      review: 'Review your history',
      timeline: 'Timeline',
      residence: 'Section 05: Places you lived',
      employment: 'Section 07: Employment history',
      education: 'Section 06: Schools & diplomas',
      federal: 'Section 08: Former federal service',
    },
    disciplinary: {
      heading: {
        label: {
          consequences: { ...disciplineSentenceOptions.asLocaleEn() },
        },
      },
    },
    residence: {
      title: 'Section 05: Where you have lived',
      info:
        'This section asks for information regarding where you have lived for the past five years. Only report information prior to your 18th birthday if necessary to report a minimum of 2 years of information.',
      info2a:
        ' - Start with your current address and work back.',
      info2b:
        ' - You must account for all periods of time without breaks: however, you do not need to account for temporary addresses of fewer than 90 days -- such as vacations, conferences, or military training or temporary duty stations of less than 90 days.',
      info2c:
        ' - List temporary addresses -- those where you were away from your home address for a period of  90 days or more (for example, extended travel, school, military training, military deployments). It does not matter if you intended to return to your home address or move to a new home address. You may or may not have changed your mailing address from your home address to the temporary address.',
      info2d:
        ' - List your home addresses -- those where you physically resided.',
      info2e:
        ' - Do not list a Post Office box.',
      info2f:
        ' - List all addresses even if you split your time between one or more addresses.',
      summary: {
        title: 'Section 05: Where you have lived',
        unit: 'Years covered',
        svgAlt: 'Years covered for locations you have lived',
      },
      comments: 'Optional Summary Comments',
      collection: {
        caption: 'Section 05:Where you have lived',
        summary: {
          title: 'Summary of places you have lived',
          item: 'Address',
          unknown: 'Provide residence details',
          incomplete: "This residence's information is incomplete",
          item2: 'Person',
        },
        append: 'Add another residence',
        appendTitle: 'Do you have another address to report within the past 5 years? (Only report information prior to your 18th birthday if necessary to report a minimum of 2 years of information.)',
      },
      date: {
        fromDate: 'When did you start living here?',
        toDate: 'When did you stop living here?',
      },
      gap: {
        title: 'Residence gap',
        para:
          'There is a gap in your residence history. The entire {{years}} year period must be covered with no gaps',
        btnText: 'Add an address',
      },
      heading: {
        done: "Done! Now let's add more",
        exiting: 'Before you leave this section',
        details: 'Enter your residence information',
        dates: 'Provide dates of residence',
        address: 'What is the address?',
        comments:
          'If you need to provide additional comments about this information enter them below',
        role: 'Is/was this residence',
      },
      para: {
        done: 'Use the button below to save your history entry and start another.',
        exiting: [
          '**The full {{years}} year period of residence history is not covered.** Your {{formName}} cannot be submitted until all {{years}} years are covered with no gaps.',
          '',
          '',
          'We will mark the gaps and highlight them for you when you come back.',
        ],
        details:
          'Indicate the actual physical location of your residence, not a Post Office box or address where you did not physically reside. If you split your time between one or more residences during a time period, you must list all residences. Do not list residences before your 18th birthday unless to provide a minimum of 2 years residence history.',
      },
      label: {
        dates:
          'You are not required to list temporary locations of less than 90 days that did not serve as your permanent or mailing address.',
        address: 'Do you currently live in the U.S.?',
        subsequent: 'Is your next address in the U.S.?',
        role: {
          owned: 'Owned by you',
          rented: 'Rented or leased by you',
          military: 'Military housing',
          other: 'Other',
          explanation: 'Please provide an explanation',
        },
        comments: 'Optional Comments',
        temporaryAddress: 'Is this a temporary address over 90 days?',
        temporaryAddressPurpose: 'What is or was the purpose of your temporary living situation?',
        temporaryAddressPurposeExplanation: 'Please Explain',
      },
      help: {
        dates: {
          title: 'Estimate the date if unsure',
          message:
            'If you are not sure of the exact dates give us your best guess and check the "Estimated" checkbox.',
          note: '',
        },
        address: {
          title: 'Acronyms:',
          message: 'APO - Army Post Office, FPO - Fleet Post Office.',
          note: '',
        },
        role: {
          title: 'Need help with the role?',
          message: 'Provide your role at this residence as closely as possible',
          note: '',
        },
        comments: {
          title: 'Need help providing additional information?',
          message:
            'If you need to provide any additional comments about this information enter them below',
          note: '',
        },
      },
      address: {
        domesticTitle: 'What is the address?',
        foreignTitle: 'Where is the residence located?',
      },
    },

    employment: {
      summary: {
        title: 'Section 07: Employment activities',
        unit: 'Years covered',
        svgAlt: 'Years covered for your employment activities',
        continuationTitle: 'Continuation of Section 07: Employment activities',
      },
      continuationIntro: {
        intro: 'This section asks questions regarding any foreign service you have had, as applicable. If you have foreign service then we want to collect information regarding your work and any foreign nationals you keep in contact with from your time serving in that foreign government.',
        introPrefix: 'For this section:',
        introItem1: 'Foreign -- means non-U.S. -- that is, outside of the 50 U.S. states, District of Columbia, and U.S. territories.',
        introItem2: 'Foreign service -- is work performed for a non-U.S. government and its agencies. Examples of foreign agencies and disciplines include foreign embassies, consulates, military or armed forces, intelligence services, diplomatic services, and security services.',
        introItem3: 'Foreign national -- is any person who is not a citizen or national of the U.S.',
      },
      foreignServiceCollection: {
        summary: {
          title: 'Summary of foreign services',
          item: 'Foreign service',
          unknown: 'Provide the foreign service below',
        },
        appendTitle:
          'Do you have another period of foreign service to report?',
        append: 'Add another foreign service',
      },
      gap: {
        title: 'Employment gap',
        para:
          'There is a gap in your employment. The entire {{years}} year period must be covered with no gaps',
        btnText: 'Add an employer',
      },
      errors: {
        duplicateListItems: {
          title: 'Resolve errors above',
        }
      },
      default: {
        noDate: {
          label: 'NA',
        },
        collection: {
          activityTypes: { ...employmentActivityTypes.asLocaleEn() },
          employmentMilitaryBranches: { ...employmentMilitaryBranchValues.asLocaleEn() },
          caption: 'Section 07: Employment activities',
          append: 'Add another employer',
          appendTitle: 'Do you have another employment activity to report within the past 5 years ? (Do not list employments before your 18th birthday unless to provide a minimum of 2 years employment history.)',
          summary: {
            title: 'Summary of your work history',
            employer: 'Employer',
            incomplete: "This employer's information is incomplete",
            unknown: 'Provide employer details',
            item2: 'Title',
          },
        },
        employmentRecord: {
          title:
            'Have any of the following happened to you in the last {{yearsString}} ({{years}}) years at employment activities that you have not previously listed?',
          list: `* Fired from a job?
* Quit a job after being told you would be fired?
* Have you left a job by mutual agreement following charges or allegations of misconduct?
* Left a job by mutual agreement following notice of unsatisfactory performance?
* Received a written warning, been officially reprimanded, suspended, or disciplined for misconduct in the workplace, such as violation of security policy?`,
          para:
            'If you answer "Yes", you will be required to add an additional employment record above.',
        },
        activity: {
          title: 'Government employment',
          help: {
            title: 'Specifics:',
            message:
              'Non-government employment represents all employment outside of the government excluding self-employment. If you were self employed, please choose self-employment. ',
            note: '',
          },
          other: {
            label: 'Explanation for other',
            help: {
              title: '',
              message: '',
              note: '',
            },
          },
          type: {
            activeMilitary: 'Active military duty station',
            nationalGuard: 'National Guard/Reserve',
            usphs: 'USPHS Commissioned Corps',
            otherFederal: 'Other federal employment',
            stateGovernment: 'State Government (Non-Federal employment)',
            federalContractor: 'Federal contractor',
            nonGovernment: 'Non-government employment (excluding self-employment)',
            selfEmployment: 'Self-employment',
            unemployment: 'Unemployment',
            other: 'Other',
            otherEmployment: 'Other employment',
          },
        },
        reasonDescription: {
          title: 'Reason for leaving employment',
          message: 'Explain why you left your last employment',
        },
        departure: {
          title: 'Provide the reason for leaving the employment activity',
          branch:
            'For this employment have any of the following happened to you in the last {{yearsString}} ({{years}}) years?',
          append:
            'In the last {{yearsString}} ({{years}}) years do you have another reason for leaving to report for this employment?',
          summary: {
            unknownPhone: 'Provide your telephone number below',
            phoneNumber: 'Phone number',
            unknownEmail: 'Provide your email below',
            email: 'Email',
          },
          phoneNumbers: {
            title: 'What is this person\'s phone number? (You may list more than one.)',
            branch: {
              title: 'Can you provide their phone number?',
            },
            timeOfDay: 'Best time to call',
            summary: {
              title: 'Summary of phone numbers',
            },
            append: 'Add another phone number',
          },
          emails: {
            title: 'Email Address',
            branch: {
              title: 'What is this person\'s email address? (You may list more than one.)',
            },
            summary: {
              title: 'Summary of emails',
            },
            append: 'Add another email',
          },
          list: [
            '- Fired',
            '- Quit after being told you would be fired',
            '- Left by mutual agreement following charges or allegations of misconduct',
            '- Left by mutual agreement following notice of unsatisfactory performance',
          ],
          comments: 'Provide any additional comments for why you left this employment activity',
          severanceTypeComments: 'Optional Comments',
          optionalComments: 'Optional Comments',
          reasonLeftComments: 'Optional Comments',
          fired: {
            title: '',
            label: 'Were you fired from this job?',
            option: 'Fired',
            date: { label: 'When were you fired' },
            inPerson: { label: 'Were you fired in person?', title: '' },
            inWriting: { label: 'Were you fired in writing?', title: '' },
            givenBy: { label: 'Who fired you?' },
            description: { label: 'Why were you fired?' },
          },
          leaveBeforeFired: {
            title: '',
            label: 'Did you quit this job after being told you would be fired?',
            inPerson: { label: 'Were you notified in person that you were going to be fired?', title: '' },
            inWriting: { label: 'Were you notified in writing that you were going to be fired?', title: '' },
            givenBy: { label: 'Who told you that you were going to be fired (in writing or in person)?' },
            description: { label: 'Why were you going to be fired?' },
          },

          leaveAfterNoticeMisconduct: {
            title: '',
            label: 'Did you leave this job after receiving allegations or a notice of misconduct?',
            inPerson: { label: 'Were you made aware or notified, in person, of this alleged or actual misconduct?', title: '' },
            inWriting: { label: 'Were you made aware or notified, in writing, of this alleged or actual misconduct?', title: '' },
            givenBy: { label: 'Who notified you of the alleged or actual misconduct in writing or in person?' },
            description: { label: 'Provide a description of the misconduct. What was the alleged or actual misconduct? (Include a description of the misconduct, when the misconduct occurred, and any other important details.)', title: '' },
          },
          leaveAfterNoticePerformance: {
            title: '',
            label: 'Did you leave this job after receiving allegations or a notice of unsatisfactory performance?',
            date: 'When were you fired',
            inPerson: { label: 'Were you made aware or notified, in person, of unsatisfactory performance?', title: '' },
            inWriting: { label: 'Were you made aware or notified, in writing, of unsatisfactory performance?', title: '' },
            givenBy: { label: 'Who notified you of the unsatisfactory performance?' },
            description: { label: 'Provide a description of the unsatisfactory performance. What was the alleged or actual unsatisfactory performance? (Include a description of the unsatisfactory performance, when the unsatisfactory performance occurred, and any other important details.)' },
          },
          leavePendingOutcome: {
            title: '',
            label: 'Did you leave this job pending the outcome of any investigation, review, or inquiry into your performance, conduct, or behavior?',
            date: 'When were you fired',
            inPerson: { label: 'Were you made aware or notified, in person, of an investigation, review, or inquiry into your performance, conduct, or behavior?', title: '' },
            inWriting: { label: 'Were you made aware or notified, in writing, of an investigation, review, or inquiry into your performance, conduct, or behavior?', title: '' },
            givenBy: { label: 'Who notified you of an investigation, review, or inquiry into your performance, conduct, or behavior?' },
            description: { label: 'Provide a description of the reason for the investigation, review, or inquiry. Why was your performance, conduct, or behavior being investigated, reviewed, or looked into?' },
          },
          quit: {
            option: 'Quit',
            text: 'Provide the reason for quitting',
            date: 'Provide the date you quit after being told you would be fired',
          },
          charges: {
            option: 'Misconduct',
            text: 'Provide the charges or allegations of misconduct',
            date: 'Provide the date you left following the charges or allegations of misconduct',
          },
          performance: {
            option: 'Unsatisfactory performance',
            text: 'Provide the reason(s) for unsatisfactory performance',
            date:
              'Provide the date you left by mutual agreement following a notice of unsatisfactory performance',
          },
        },
        datesEmployed: {
          help: {
            title: 'Estimate the date if unsure',
            message:
              'If you are not sure of the exact dates give us your best guess and check the "Estimated" checkbox.',
            note: '',
          },
        },
        address: {
          label: 'Is or was your work address in the U.S.? (Your work address is where you physically work or worked.)',
          domesticTitle: 'What is or was your work address?',
          foreignTitle: 'Where is or was your work located?',
          help: {
            title: 'Acronyms:',
            message: 'APO - Army Post Office, FPO - Fleet Post Office.',
            note: '',
          },
        },
        status: {
          help: {
            title: 'Need help with the employment status?',
            message: 'Select the employment status',
            note: '',
          },
          fullTime: 'Full-time',
          partTime: 'Part-time',
        },
        telephone: {
          label: '',
          help: {
            title: 'Need help with the telephone number?',
            message: 'Provide the telephone number',
            note: '',
          },
        },
        phoneNumbers: {
          title: 'What is this person\'s phone number? (You may list more than one.)',
          branch: {
            title: 'Can you provide their phone number?',
          },
          timeOfDay: 'Best time to call',
          summary: {
            title: 'Summary of phone numbers',
          },
          append: 'Add another phone number',
        },
        emails: {
          title: 'Email Address',
          branch: {
            title: 'What is this person\'s email address? (You may list more than one.)',
          },
          summary: {
            title: 'Summary of emails',
          },
          append: 'Add another email',
        },
        title: {
          label: 'Title',
          help: {
            title: 'Need help with the position title?',
            message: 'Provide the name of your position title',
            note: '',
          },
        },
        employer: {
          label: 'Employer name',
          help: {
            title: 'Need help with the employer name?',
            message: 'Provide the name of your employer',
            note: '',
          },
        },
        physicalAddress: {
          help: {
            title: 'Are/were you working from another location?',
            message:
              'Are/were you physically working from an different location than your employer\'s address? If so answer "Yes".',
            note: '',
          },
          address: {
            label: 'This address is',
            help: {
              title: 'Acronyms:',
              message:
                'APO - Army Post Office, FPO - Fleet Post Office.',
              note: '',
            },
          },
          heading: {
            telephone: 'Provide telephone number',
            address: 'Provide the work address where you are/were physically located',
          },
          answercomments: 'Optional Comments',
          addresscomments: 'Optional Comments',
        },
        domesticTitle: "What is this employer's address?",
        foreignTitle: 'Where is this employer currently located?',
        isInUS: "Is this employer's current address in the U.S.?",
        additionalActivity: {
          help: {
            title: 'Need help with any additional periods of activity?',
            message: 'Do you have any additional periods of activity to add?',
            note: '',
          },
          label: 'Do you have any additional periods of activity to add?',
          collection: {
            append: 'Add additional periods',
          },
          heading: {
            position: 'Provide position title',
            supervisor: 'Provide supervisor',
            datesEmployed: 'Dates of employment',
          },
          position: {
            label: 'Position title',
            help: {
              title: 'Need help with the position title?',
              message: 'Provide the position title',
              note: '',
            },
          },
          supervisor: {
            label: 'Supervisor',
            help: {
              title: 'Need help with the supervisor?',
              message: 'Provide the supervisor name',
              note: '',
            },
          },
          datesEmployed: {
            help: {
              title: 'Need help with the dates of employment?',
              message:
                'If you are not sure of the exact dates give us your best guess and check the "Estimated" checkbox.',
              note: '',
            },
          },
        },
        assignment: {
          append: 'Do you have another unit or organization you were assigned to while at this duty station? (Answer "Yes" if the assignments were consecutive (back-to-back). Answer "No" if you left this duty station and there was a time gap before returning to this duty station.)',
          branch: {
            title: 'Do you have a unit or organization at this Duty Station?',
          }

        },
        reprimand: {
          label:
            'Did you receive any disciplinary actions during this employment? (Examples of disciplinary actions include terminations, written warnings, official reprimands, official counseling, and suspensions)',
          append: 'Do you have another disciplinary action during this employment to report?',
          federalAppend: 'Do you have another disciplinary action for this period of federal employment to report ?',
          militaryLabel: 'Did you receive any disciplinary actions while assigned to this duty station?',
          militaryAppend: 'Do you have another disciplinary action while assigned to this duty station to report?',
          description: {
            label: 'Why did you receive this disciplinary action? (Include a description of the offense for which you received this disciplinary action, when the offense occurred, and any other important details.)',
          },
          name: 'Who gave you this disciplinary action?',
          nameNotApplicable: "I don't know",
          givenByRank: 'Rank',
          rankUnknown: "I don't know",
          type: 'Which disciplinary action did you receive? (Check one. There will be an opportunity to input multiple entries.)',
          date: {
            label:
              'When did you receive this disciplinary action?',
          },
          help: {
            title: 'Have you received a written warning',
            message:
              'Explain if you have you received a written warning, been officially reprimanded, suspended, or disciplined for misconduct in the workplace, such as a violation of security policy',
          },
          otherExplaination: 'Please explain.',
        },
        left: {
          title: 'Why did you leave this job?',
        },
        supervisor: {
          name: {
            label: 'Supervisor name',
            help: {
              title: 'Need help with the supervisor name?',
              message: 'Provide the name of this supervisor',
              note: '',
            },
          },
          title: {
            label: 'Supervisor position title',
            help: {
              title: 'Need help with the position title?',
              message: 'Provide the position title of this supervisor',
              note: '',
            },
          },
          email: {
            label: 'Supervisor email',
            help: {
              title: 'Need help with the email?',
              message: 'Provide the email of this supervisor',
              note: '',
            },
          },
          hasdifferentaddress: {
            label: "Is/was your supervisor's physical work address different than your Job Location?",
            title: 'Is/was your supervisor working from another location?',
            message:
              'Is/was your supervisor physically working from a different location than your employer\'s address? If so answer "Yes".',
            note: '',
          },
          heading: {
            address: 'Supervisor Address Details',
            name: 'Who is or was your most recent supervisor?',
            titleMilitary: 'What is or was this supervisor\'s duty or job title?',
            title: 'What is or was this supervisor\'s job title?',
            email: 'What is this supervisor\'s email address?',
            telephone: 'What is this supervisor\'s phone number?',
            emails: 'What is your supervisor\'s email address? (You may list more than one.)',
            emailsAppend: 'Do you have another email address to add?',
            emailsEmailFieldTitle: 'Email Address',
            telephones: 'What is your supervisor\'s phone number? (You may list more than one.)',
            telephonesAppend: 'Do you have another phone number to add?',
            assignedUnitOrg: 'What unit or organization is this supervisor currently assigned to?',
          },
          address: {
            label: 'Does this supervisor currently work in the U.S.?',
            domesticTitle: 'What is this supervisor\'s current work address?',
            foreignTitle: 'Where does this supervisor currently work?',
            help: {
              title: 'Tell us where your supervisor works/worked',
              message: "Provide the physical address of this supervisor's work location.",
              note: '',
            },
          },
          telephone: {
            help: {
              title: 'Need help with the telephone number?',
              message: 'Provide the telephone number for this supervisor',
              note: '',
            },
          },
        },
        heading: {
          name: 'Who is or was your most recent supervisor?',
          title: 'What is or was this supervisor\'s duty or job title?',
          titleNonMilitary: 'What is or was this supervisor\'s job title?',
          email: 'What is this supervisor\'s email address?',
          address: 'Is this employer\'s current address in the U.S.? ',
          differentPhysicalAddress: 's or was your work address different than this employer’s address? (Your work address is where you physically work or worked.)',
          physicalAddress: 'Is or was your work address in the U.S.? (Your work address is where you physically work or worked.)',
          telephone: 'What is this employer\'s phone number? ',
          datesEmployed: 'When did you work for this employer?',
          assignedUnitOrg: 'What unit or organization are you or were you assigned to?',
          assignedUnitOrgDateRange: 'When were you assigned to this unit or organization? (These dates may or may not match the dates you were assigned to the duty station above -- it depends on whether or not you were assigned to more than one unit or organization while assigned to this duty station.)',
          assignedUnitOrgTelephone: 'What is the phone number of your unit or organization?',
          assignedUnitOrgDutyStatus: 'What is or was your duty status while assigned to this unit or organization?',
          assignedUnitOrgTitle: 'What is or was your duty or job title while assigned to this unit or organization?',
        },
      },
      heading: {
        activity: 'What type of employment activity do you have to report?',
        additionalActivity: 'Additional periods of activity with this employer',
        address: 'Is this employer\'s current address in the U.S.?',
        agency: 'What foreign agency do you or did you serve in? (Do not use acronyms.)',
        civilianOrMilitary: 'Are you or were you a civilian or a military member?',
        consequences: 'What were the consequences of this disciplinary action? (Select all that apply.)',
        country: 'What country is or was your foreign service for?',
        dateLastContacted: 'When was your last contact with this individual?',
        dateMet: 'When did you meet this individual?',
        datesEmployed: 'When did you work for this employer?',
        datesServed: 'When did you serve in this foreign agency?',
        department: 'Which division, department, or office do you or did you serve in? (Do not use acronyms.)',
        done: "Done! Now let's add more",
        employer: 'Who is or was your employer? (Do not use abbreviations unless the name of this employment includes abbreviations.)',
        employment: 'List where you have worked',
        exiting: 'Before you leave this section',
        explanation: 'Please explain.',
        foreignContact: 'Do you maintain contact with any foreign nationals from your time working at this foreign agency? ("maintain contact" includes "now" and an intent to have contact in the future.)',
        foreignContactAddessDomesticTitle: 'What is their address?',
        foreignContactAddress: 'Does this person live or work in the U.S.?',
        foreignContactAddressForeignTitle: 'Where are they located?',
        foreignContactAppend: 'Do you have another foreign national with whom you maintain contact from your time working at this foreign agency to report?',
        foreignContactRank: 'What is their job title and rank if applicable?',
        foreignDiscipline: 'Which foreign government discipline do you or did you serve in?',
        foreignName: 'What is their name?',
        frequency: 'How often do you have contact with this individual?',
        hasDifferentPhysical: 'Is or was your work address different than this employer\'s address? (Your work address is where you physically work or worked.)',
        hasForeignService: 'Have you ever served in a foreign government?',
        howAssociated: 'How did you become associated with this foreign agency?',
        isInternship: 'Is this an internship?',
        physicalAddress: 'Is or was your work address in the U.S.? (Your work address is where you physically work or worked.)',
        rank: 'What is the highest position or rank you held in this foreign agency?',
        reasonLeft: 'Why did you leave this foreign agency?',
        reference: 'Provide a reference',
        relationship: 'What is your current relationship with this person?',
        status: 'Select the employment status for this position',
        stillInBusiness: 'Is this employer still in business?',
        supervisor: 'Your Supervisor',
        telephone: 'Provide telephone number',
        title: 'What is or was your job title?',
      },
      para: {
        or: 'or',
        idk: 'I don\'t know',
        additionalActivity:
          'Provide additional periods of activity if you worked for this employer on more than one occasion at the same physical location (for example, if you worked at XY Plumbing in Denver, CO, during 3 separate periods of time you would enter information concerning the most recent period of employment above, and provide dates, position titles, and supervisors for the two previous periods of employment as entries below).',
        exiting: [
          '**The full {{years}} year period of employment history is not covered.** Your {{formName}} cannot be submitted until all {{years}} years are covered with no gaps.',
          '',
          '',
          'We will mark the gaps and highlight them for you when you come back.',
        ],
        employment: 'This section asks questions regarding your employment activities for the past five years.',
        employment2: 'Do not list employment before your 18th birthday unless to provide a minimum of 2 years employment history.',
        employment3: '(Start with your current employment activity and work back.) You must list all periods of employment, whether they are full-time or part-time, as well as periods of unemployment and self-employment without any breaks. Include paid and unpaid internships or fellowships, but do not include volunteer work. For military and uniformed service, list each duty station you were assigned to as a separate employment activity.',
      },
      usmilitary: {
        heading: {
          title: 'What is or was your duty or job title while assigned to this unit or organization?',
          status: 'Select the employment status for this position',
          datesEmployed: 'When were you assigned here?',
          address: 'What is the address for this duty station?',
          telephone: 'What is the phone number of your unit or organization?',
          supervisor: 'Your Supervisor',
          reference: 'Provide a reference',
          hasDifferentPhysical: 'Is or was your work address different than this employer\'s address? (Your work address is where you physically work or worked.)',
          physicalAddress:
            'Is or was your work address in the U.S.? (Your work address is where you physically work or worked.)',
          supervisorPhysicalAddress:
            'Is/was your supervisors physical work address different than your Job Location?',
          additionalActivity: 'Additional periods of activity with this employer',
          dutyStation: 'What is the name of the duty station you are or were assigned to?',
          militaryBranch: 'Which branch of service are you or were you in?',
          courtMatial: 'You indicated you were court-martialed in the past five years. You will be asked for information regarding your court-martial in Section 9, U.S. Military or U.S. Uniformed Service. ',
          militaryBranchOptions: { ...(employmentMilitaryBranchValues.asLocaleEn()) }
        },
        title: {
          label: 'Title',
          help: {
            title: 'Need help with the position title?',
            message: 'Provide the name of your position title',
            note: '',
          },
        },
        status: {
          help: {
            title: 'Need help with the employment status?',
            message: 'Select the employment status',
            note: '',
          },
        },
        address: {
          label: 'Is this duty station in the U.S.?',
          domesticTitle: 'What is the address for this duty station?',
          foreignTitle: 'Where is the duty station located?\nPlease provide physical address (not mailing address)',
          help: {
            title: 'Acronyms:',
            message: 'APO - Army Post Office, FPO - Fleet Post Office.',
            note: '',
          },
        },
        telephone: {
          label: '',
          help: {
            title: 'Need help with the telephone number?',
            message: 'Provide the telephone number',
            note: '',
          },
        },
        supervisor: {
          name: {
            label: 'Supervisor name',
            help: {
              title: 'Need help with the supervisor name?',
              message: 'Provide the name of this supervisor',
              note: '',
            },
          },
          title: {
            label: 'Supervisor position title',
            help: {
              title: 'Need help with the position title?',
              message: 'Provide the position title of this supervisor',
              note: '',
            },
          },
          email: {
            label: 'Supervisor email',
            help: {
              title: 'Provide the email of this supervisor',
              message: 'Only provide an active email address where this supervisor can be reached.',
              note: '',
            },
          },
          address: {
            label: 'This address is',
            help: {
              title: 'Acronyms:',
              message:
                'APO - Army Post Office, FPO - Fleet Post Office.',
              note: '',
            },
          },
          telephone: {
            help: {
              title: 'Need help with the telephone number?',
              message: 'Provide the telephone number for this supervisor',
              note: '',
            },
          },
          heading: {
            name: 'Provide the name of your supervisor',
            title: 'Provide the position title of your supervisor',
            email: 'Provide the email address of your supervisor',
            address: 'Provide the physical work location of your supervisor',
            telephone: 'Provide the telephone number for this supervisor',
          },
        },
        additionalActivity: {
          help: {
            title: 'Need help with additional periods of activity?',
            message: 'Do you have any additional periods of activity to add?',
            note: '',
          },
          label: 'Do you have any additional periods of activity to add?',
          collection: {
            append: 'Add additional periods',
          },
          heading: {
            position: 'Provide position title',
            supervisor: 'Provide supervisor',
            datesEmployed: 'Provide dates of employment',
          },
          position: {
            label: 'Position',
            help: {
              title: 'Need help with the position title?',
              message: 'Provide the position title',
              note: '',
            },
          },
          supervisor: {
            label: 'Supervisor',
            help: {
              title: 'Need help with the name?',
              message: 'Provide the supervisor name',
              note: '',
            },
          },
          datesEmployed: {
            help: {
              title: 'Need help with the dates of employment?',
              message: 'Provide dates of employment',
              note: '',
            },
          },
        },
        dutyStation: {
          label: 'Duty station',
        },
        para: {
          additionalActivity:
            'Provide additional periods of activity if you worked for this employer on more than one occasion at the same physical location (for example, if you worked at XY Plumbing in Denver, CO, during 3 separate periods of time you would enter information concerning the most recent period of employment above, and provide dates, position titles, and supervisors for the two previous periods of employment as entries below).',
        },
      },
      nationalguard: {
        heading: {
          title: 'Provide your most recent rank/position title',
          status: 'Select the employment status for this position',
          address: 'Provide address of duty station',
          telephone: 'Provide telephone number',
          supervisor: 'Your Supervisor',
          reference: 'Provide a reference',
          hasDifferentPhysical: 'Is or was your work address different than this employer\'s address? (Your work address is where you physically work or worked.)',
          physicalAddress:
            'Is or was your work address in the U.S.? (Your work address is where you physically work or worked.)',
          additionalActivity: 'Additional periods of activity with this employer',
          dutyStation: 'Provide your assigned duty station during this period',
        },
        title: {
          label: 'Title',
          help: {
            title: 'Need help with the rank/position title?',
            message: 'Provide your most recent rank/position title',
            note: '',
          },
        },
        status: {
          help: {
            title: 'Need help with the employment status?',
            message: 'Select the employment status',
            note: '',
          },
        },
        address: {
          label: 'This address is',
          help: {
            title: 'Acronyms:',
            message: 'APO - Army Post Office, FPO - Fleet Post Office.',
            note: '',
          },
        },
        telephone: {
          label: '',
          help: {
            title: 'Need help with the phone number?',
            message: 'Provide the telephone number',
            note: '',
          },
        },
        supervisor: {
          name: {
            label: 'Supervisor name',
            help: {
              title: 'Need help with the supervisor name?',
              message: 'Provide the name of this supervisor',
              note: '',
            },
          },
          title: {
            label: 'Supervisor position title',
            help: {
              title: 'Need help with the position title?',
              message: 'Provide the position title of this supervisor',
              note: '',
            },
          },
          email: {
            label: 'Supervisor email',
            help: {
              title: 'Need help with the email address?',
              message: 'Provide the email of this supervisor',
              note: '',
            },
          },
          address: {
            label: 'This address is',
            help: {
              title: 'Tell us where your supervisor works/worked',
              message: "Provide the physical address of this supervisor's work location.",
              note: '',
            },
          },
          telephone: {
            help: {
              title: 'Need help with the telephone number?',
              message: 'Provide the telephone number for this supervisor',
              note: '',
            },
          },
          heading: {
            name: 'Provide the name of your supervisor',
            title: 'Provide the position title of your supervisor',
            email: 'Provide the email address of your supervisor',
            address: 'Provide the physical work location of your supervisor',
            telephone: 'Provide the telephone number for this supervisor',
          },
        },
        additionalActivity: {
          help: {
            title: 'Need help with additional periods of activity?',
            message: 'Do you have any additional periods of activity to add?',
            note: '',
          },
          label: 'Do you have any additional periods of activity to add?',
          collection: {
            append: 'Add additional periods',
          },
          heading: {
            position: 'Provide position title',
            supervisor: 'Provide supervisor',
            datesEmployed: 'Provide dates of employment',
          },
          position: {
            label: 'Position',
            help: {
              title: 'Need help with the position title?',
              message: 'Provide the position title',
              note: '',
            },
          },
          supervisor: {
            label: 'Supervisor',
            help: {
              title: 'Need help with the supervisor name?',
              message: 'Provide the supervisor name',
              note: '',
            },
          },
          datesEmployed: {
            help: {
              title: 'Need help with the dates of employment?',
              message: 'Provide dates of employment',
              note: '',
            },
          },
        },
        dutyStation: {
          label: 'Duty station',
        },
        para: {
          additionalActivity:
            'Provide additional periods of activity if you worked for this employer on more than one occasion at the same physical location (for example, if you worked at XY Plumbing in Denver, CO, during 3 separate periods of time you would enter information concerning the most recent period of employment above, and provide dates, position titles, and supervisors for the two previous periods of employment as entries below).',
        },
      },
      usphs: {
        heading: {
          title: 'Provide your most recent rank/position title',
          status: 'Select the employment status for this position',
          address: 'Provide address of duty station',
          telephone: 'Provide telephone number',
          supervisor: 'Your Supervisor',
          reference: 'Provide a reference',
          hasDifferentPhysical: 'Is or was your work address different than this employer\'s address? (Your work address is where you physically work or worked.)',
          physicalAddress:
            'Is or was your work address in the U.S.? (Your work address is where you physically work or worked.)',
          additionalActivity: 'Additional periods of activity with this employer',
          dutyStation: 'Provide your assigned duty station during this period',
        },
        title: {
          label: 'Title',
          help: {
            title: 'Need help with the rank/position title?',
            message: 'Provide your most recent rank/position title',
            note: '',
          },
        },
        status: {
          help: {
            title: 'Need help with the employment status?',
            message: 'Select the employment status',
            note: '',
          },
        },
        address: {
          label: 'This address is',
          help: {
            title: 'Acronyms:',
            message: 'APO - Army Post Office, FPO - Fleet Post Office.',
            note: '',
          },
        },
        telephone: {
          label: '',
          help: {
            title: 'Need help with the telephone number?',
            message: 'Provide the telephone number',
            note: '',
          },
        },
        supervisor: {
          name: {
            label: 'Supervisor name',
            help: {
              title: 'Need help with the supervisor name?',
              message: 'Provide the name of this supervisor',
              note: '',
            },
          },
          title: {
            label: 'Supervisor position title',
            help: {
              title: 'Need help with the position title?',
              message: 'Provide the position title of this supervisor',
              note: '',
            },
          },
          email: {
            label: 'Supervisor email',
            help: {
              title: 'Need help with the email address?',
              message: 'Provide the email of this supervisor',
              note: '',
            },
          },
          address: {
            label: 'This address is',
            help: {
              title: 'Tell us where your supervisor works/worked',
              message: "Provide the physical address of this supervisor's work location.",
              note: '',
            },
          },
          telephone: {
            help: {
              title: 'Need help with the telephone number?',
              message: 'Provide the telephone number for this supervisor',
              note: '',
            },
          },
          heading: {
            name: 'Provide the name of your supervisor',
            title: 'Provide the position title of your supervisor',
            email: 'Provide the email address of your supervisor',
            address: 'Provide the physical work location of your supervisor',
            telephone: 'Provide the telephone number for this supervisor',
          },
        },
        additionalActivity: {
          help: {
            title: 'Need help with additional periods of activity?',
            message: 'Do you have any additional periods of activity to add?',
            note: '',
          },
          label: 'Do you have any additional periods of activity to add?',
          collection: {
            append: 'Add additional periods',
          },
          heading: {
            position: 'Provide position title',
            supervisor: 'Provide supervisor',
            datesEmployed: 'Provide dates of employment',
          },
          position: {
            label: 'Position',
            help: {
              title: 'Need help with the position title?',
              message: 'Provide the position title',
              note: '',
            },
          },
          supervisor: {
            label: 'Supervisor',
            help: {
              title: 'Need help with the supervisor name?',
              message: 'Provide the supervisor name',
              note: '',
            },
          },
          datesEmployed: {
            help: {
              title: 'Need help with the dates of employment?',
              message: 'Provide dates of employment',
              note: '',
            },
          },
        },
        dutyStation: {
          label: 'Duty station',
        },
        para: {
          additionalActivity:
            'Provide additional periods of activity if you worked for this employer on more than one occasion at the same physical location (for example, if you worked at XY Plumbing in Denver, CO, during 3 separate periods of time you would enter information concerning the most recent period of employment above, and provide dates, position titles, and supervisors for the two previous periods of employment as entries below).',
        },
      },
      otherfederal: {
        heading: {
          employer: 'Provide the name of your employer',
          title: 'Provide the most recent position title',
          status: 'Select the employment status for this position',
          address: 'Provide the address of employer',
          telephone: 'Provide telephone number',
          reference: 'Provide a reference',
          hasDifferentPhysical: 'Is or was your work address different than this employer\'s address? (Your work address is where you physically work or worked.)',
          physicalAddress:
            'Is or was your work address in the U.S.? (Your work address is where you physically work or worked.)',
          supervisorPhysicalAddress:
            'Is/was your supervisors physical work address different than your Job Location?',
          additionalActivity: 'Additional periods of activity with this employer',
        },
        para: {
          additionalActivity:
            'Provide additional periods of activity if you worked for this employer on more than one occasion at the same physical location (for example, if you worked at XY Plumbing in Denver, CO, during 3 separate periods of time you would enter information concerning the most recent period of employment above, and provide dates, position titles, and supervisors for the two previous periods of employment as entries below).',
        },
        employer: {
          label: 'Employer name',
          help: {
            title: 'Need help with the employer name?',
            message: 'Provide the name of your employer',
            note: '',
          },
        },
        title: {
          label: 'Title',
          help: {
            title: 'Need help with the position title?',
            message: 'Provide the name of your position title',
            note: '',
          },
        },
        status: {
          help: {
            title: 'Need help with the employment status?',
            message: 'Select the employment status',
            note: '',
          },
        },
        address: {
          label: 'This address is',
          help: {
            title: 'Acronyms:',
            message:
              'Acronyms: APO - Army Post Office, FPO - Fleet Post Office.',
            note: '',
          },
        },
        telephone: {
          label: '',
          help: {
            title: 'Need help with the telephone number?',
            message: 'Provide the telephone number',
            note: '',
          },
        },
        physicalAddress: {
          help: {
            title: 'Are/were you working from another location?',
            message:
              'Are/were you physically working from a different location than your employer\'s address? If so answer "Yes".',
            note: '',
          },
          address: {
            label: 'This address is',
          },
          heading: {
            telephone: 'Provide telephone number',
            address: 'Provide the address of physical location',
          },
        },
        additionalActivity: {
          help: {
            title: 'Need help with additional periods of activity?',
            message: 'Do you have any additional periods of activity to add?',
            note: '',
          },
          label: 'Do you have any additional periods of activity to add?',
          collection: {
            append: 'Add additional periods',
          },
          heading: {
            position: 'Provide position title',
            supervisor: 'Provide supervisor',
            datesEmployed: 'Provide dates of employment',
          },
          position: {
            label: 'Position',
            help: {
              title: 'Need help with the position title?',
              message: 'Provide the position title',
              note: '',
            },
          },
          supervisor: {
            label: 'Supervisor',
            help: {
              title: 'Need help with the supervisor name?',
              message: 'Provide the supervisor name',
              note: '',
            },
          },
          datesEmployed: {
            help: {
              title: 'Need help with the dates of employment?',
              message: 'Provide dates of employment',
              note: '',
            },
          },
        },
        returnToWork: 'Did you work for this employer for another period during the past five years? (Do not list employments before your 18th birthday unless to provide a minimum of 2 years employment history)',
      },
      stategovernment: {
        heading: {
          employer: 'Provide the name of your employer',
          title: 'Provide the most recent position title',
          status: 'Select the employment status for this position',
          address: 'Provide the address of employer',
          telephone: 'Provide telephone number',
          reference: 'Provide a reference',
          hasDifferentPhysical: 'Is or was your work address different than this employer\'s address? (Your work address is where you physically work or worked.)',
          physicalAddress:
            'Is or was your work address in the U.S.? (Your work address is where you physically work or worked.)',
          supervisorPhysicalAddress:
            'Is/was your supervisors physical work address different than your Job Location?',
          additionalActivity: 'Additional periods of activity with this employer',
        },
        para: {
          additionalActivity:
            'Provide additional periods of activity if you worked for this employer on more than one occasion at the same physical location (for example, if you worked at XY Plumbing in Denver, CO, during 3 separate periods of time you would enter information concerning the most recent period of employment above, and provide dates, position titles, and supervisors for the two previous periods of employment as entries below).',
        },
        employer: {
          label: 'Employer name',
          help: {
            title: 'Need help with the employer name?',
            message: 'Provide the name of your employer',
            note: '',
          },
        },
        title: {
          label: 'Title',
          help: {
            title: 'Need help with the position title?',
            message: 'Provide the name of your position title',
            note: '',
          },
        },
        status: {
          help: {
            title: 'Need help with the employment status?',
            message: 'Select the employment status',
            note: '',
          },
        },
        address: {
          label: 'This address is',
          help: {
            title: 'Acronyms:',
            message: 'APO - Army Post Office, FPO - Fleet Post Office.',
            note: '',
          },
        },
        telephone: {
          label: '',
          help: {
            title: 'Need help with the telephone number?',
            message: 'Provide the telephone number',
            note: '',
          },
        },
        physicalAddress: {
          help: {
            title: 'Are/were you working from another location?',
            message:
              'Are/were you physically working from a different location than your employer\'s address? If so answer "Yes".',
            note: '',
          },
          address: {
            label: 'This address is',
          },
          heading: {
            telephone: 'Provide telephone number',
            address: 'Provide the address of physical location',
          },
        },
        additionalActivity: {
          help: {
            title: 'Need help with additional periods of activity?',
            message: 'Do you have any additional periods of activity to add?',
            note: '',
          },
          label: 'Do you have any additional periods of activity to add?',
          collection: {
            append: 'Add additional periods',
          },
          heading: {
            position: 'Provide position title',
            supervisor: 'Provide supervisor',
            datesEmployed: 'Provide dates of employment',
          },
          position: {
            label: 'Position',
            help: {
              title: 'Need help with the position title?',
              message: 'Provide the position title',
              note: '',
            },
          },
          supervisor: {
            label: 'Supervisor',
            help: {
              title: 'Need help with the supervisor name?',
              message: 'Provide the supervisor name',
              note: '',
            },
          },
          datesEmployed: {
            help: {
              title: 'Need help with the dates of employment?',
              message: 'Provide dates of employment',
              note: '',
            },
          },
        },
      },
      federalcontractor: {
        heading: {
          employer: 'Provide the name of your employer',
          title: 'Provide the most recent position title',
          status: 'Select the employment status for this position',
          address: 'Provide the address of employer',
          telephone: 'Provide telephone number',
          reference: 'Provide a reference',
          hasDifferentPhysical: 'Is or was your work address different than this employer\'s address? (Your work address is where you physically work or worked.)',
          physicalAddress:
            'Is or was your work address in the U.S.? (Your work address is where you physically work or worked.)',
          supervisorPhysicalAddress:
            'Is/was your supervisors physical work address different than your Job Location?',
          additionalActivity: 'Additional periods of activity with this employer',
        },
        para: {
          additionalActivity:
            'Provide additional periods of activity if you worked for this employer on more than one occasion at the same physical location (for example, if you worked at XY Plumbing in Denver, CO, during 3 separate periods of time you would enter information concerning the most recent period of employment above, and provide dates, position titles, and supervisors for the two previous periods of employment as entries below).',
        },
        employer: {
          label: 'Employer name',
          help: {
            title: 'Need help with the employer name?',
            message: 'Provide the name of your employer',
            note: '',
          },
        },
        title: {
          label: 'Title',
          help: {
            title: 'Need help with the position title?',
            message: 'Provide the name of your position title',
            note: '',
          },
        },
        status: {
          help: {
            title: 'Need help with the employment status?',
            message: 'Select the employment status',
            note: '',
          },
        },
        address: {
          label: 'This address is',
          help: {
            title: 'Acronyms:',
            message: 'APO - Army Post Office, FPO - Fleet Post Office.',
            note: '',
          },
        },
        telephone: {
          label: '',
          help: {
            title: 'Need help with the telephone number?',
            message: 'Provide the telephone number',
            note: '',
          },
        },
        physicalAddress: {
          help: {
            title: 'Are/were you working from another location?',
            message:
              'Are/were you physically working from an different location than your employer\'s address? If so answer "Yes".',
            note: '',
          },
          address: {
            label: 'This address is',
          },
          heading: {
            telephone: 'Provide telephone number',
            address: 'Provide the address of physical location',
          },
        },
        additionalActivity: {
          help: {
            title: 'Need help with additional periods of activity?',
            message: 'Do you have any additional periods of activity to add?',
            note: '',
          },
          label: 'Do you have any additional periods of activity to add?',
          collection: {
            append: 'Add additional periods',
          },
          heading: {
            position: 'Provide position title',
            supervisor: 'Provide supervisor',
            datesEmployed: 'Provide dates of employment',
          },
          position: {
            label: 'Position',
            help: {
              title: 'Need help with position title?',
              message: 'Provide the position title',
              note: '',
            },
          },
          supervisor: {
            label: 'Supervisor',
            help: {
              title: 'Need help with the supervisor name?',
              message: 'Provide the supervisor name',
              note: '',
            },
          },
          datesEmployed: {
            help: {
              title: 'Need help with the dates of employment?',
              message: 'Provide dates of employment',
              note: '',
            },
          },
        },
      },
      nongovernment: {
        heading: {
          employer: 'Provide the name of your employer',
          title: 'Provide the most recent position title',
          status: 'Were you full-time or part-time?',
          address: 'Provide the address of employer',
          telephone: 'Provide telephone number',
          reference: 'Provide a reference',
          hasDifferentPhysical: 'Is or was your work address different than this employer\'s address? (Your work address is where you physically work or worked.)',
          physicalAddress:
            'Is or was your work address in the U.S.? (Your work address is where you physically work or worked.)',
          additionalActivity: 'Additional periods of activity with this employer',
        },
        para: {
          additionalActivity:
            'Provide additional periods of activity if you worked for this employer on more than one occasion at the same physical location (for example, if you worked at XY Plumbing in Denver, CO, during 3 separate periods of time you would enter information concerning the most recent period of employment above, and provide dates, position titles, and supervisors for the two previous periods of employment as entries below).',
        },
        employer: {
          label: 'Employer name',
          help: {
            title: 'Need help with the employer name?',
            message: 'Provide the name of your employer',
            note: '',
          },
        },
        title: {
          label: 'Title',
          help: {
            title: 'Need help with the position title?',
            message: 'Provide the name of your position title',
            note: '',
          },
        },
        status: {
          help: {
            title: 'Need help with employment status?',
            message: 'Select the employment status',
            note: '',
          },
        },
        address: {
          label: 'This address is',
          help: {
            title: 'Acronyms:',
            message: 'APO - Army Post Office, FPO - Fleet Post Office.',
            note: '',
          },
        },
        telephone: {
          label: '',
          help: {
            title: 'Need help with the telephone number?',
            message: 'Provide the telephone number',
            note: '',
          },
        },
        physicalAddress: {
          help: {
            title: 'Are/were you working from another location?',
            message:
              'Are/were you physically working from an different location than your employer\'s address? If so answer "Yes".',
            note: '',
          },
          address: {
            label: 'This address is',
          },
          heading: {
            telephone: 'Provide telephone number',
            address: 'Provide the address of physical location',
          },
        },
        additionalActivity: {
          help: {
            title: 'Need help with additional periods of activity?',
            message: 'Do you have any additional periods of activity to add?',
            note: '',
          },
          label: 'Do you have any additional periods of activity to add?',
          collection: {
            append: 'Add additional periods',
          },
          heading: {
            position: 'Provide position title',
            supervisor: 'Provide supervisor',
            datesEmployed: 'Provide dates of employment',
          },
          position: {
            label: 'Position',
            help: {
              title: 'Need help with the position title?',
              message: 'Provide the position title',
              note: '',
            },
          },
          supervisor: {
            label: 'Supervisor',
            help: {
              title: 'Need help with the supervisor name?',
              message: 'Provide the supervisor name',
              note: '',
            },
          },
          datesEmployed: {
            help: {
              title: 'Need help with the dates of employment?',
              message: 'Provide dates of employment',
              note: '',
            },
          },
        },
      },
      selfemployment: {
        notApplicable: 'Not Applicable',
        heading: {
          title: 'Provide the most recent position title',
          status: 'Were you self-employed full time or part time?',
          reference: 'Provide the name of someone that can verify your self-employment',
          physicalAddress: 'Is your physical work address different than your employment address?',
          militaryAddress: 'Does your self-employment verifier have an APO/FPO address?',
          additionalActivity: 'Additional periods of activity with this employer',
          hasAssociatedCompany: 'Is or was there a company associated with this self-employment?',
          employer: 'What is or was the name of your company? (Do not use abbreviations, unless the name includes abbreviations.)',
          stillInBusiness: 'Is your company still in business?',
          telephone: `What is or was your company's phone number?`,
          selfEmployedEmail: `What is or was your company's email address?`,
          selfEmployedWebsite: `What is or was your company's web address?`,
          isHomeCompany: `Is or was your company's address the same as your current home address?`,
          dates: 'When were you self-employed?',
          address: {
            label: 'Is or was your company based in the U.S.?',
            domesticTitle: "What is or was your company's address?",
            foreignTitle: 'Where is or was your company located?',
          },
          hasDifferentPhysicalWorkAddress: `Is or was your work address different than your company's address?`,
          physicalWorkAddress: {
            domesticTitle: 'What is or was your work address?',
            foreignTitle: 'Where is or was your work located?',
          },
        },
        employer: {
          label: 'Employer name',
          help: {
            title: 'Need help with the employer name?',
            message: 'Provide the name of your employer',
            note: '',
          },
        },
        title: {
          label: 'Title',
          help: {
            title: 'Need help with the position title?',
            message: 'Provide the name of your position title',
            note: '',
          },
        },
        status: {
          help: {
            title: 'Need help with the employment status?',
            message: 'Select the employment status',
            note: '',
          },
        },
        address: {
          label: 'This address is',
          help: {
            title: 'Acronyms:',
            message: 'APO - Army Post Office, FPO - Fleet Post Office.',
            note: '',
          },
        },
        telephone: {
          label: '',
          help: {
            title: 'Need help with the telephone number?',
            message: 'Provide the telephone number',
            note: '',
          },
        },
        physicalAddress: {
          help: {
            title: 'Are/were you working from another location?',
            message:
              'Are/were you physically working from an different location than your employer\'s address? If so answer "Yes".',
            note: '',
          },
          address: {
            label: 'This address is',
          },
          heading: {
            telephone: 'Provide telephone number',
            address: 'Provide the address of physical location',
          },
        },
        additionalActivity: {
          help: {
            title: 'Need help with additional periods of activity?',
            message: 'Do you have any additional periods of activity to add?',
            note: '',
          },
          label: 'Do you have any additional periods of activity to add?',
          collection: {
            append: 'Add additional periods',
          },
          heading: {
            position: 'Provide position title',
            supervisor: 'Provide supervisor',
            datesEmployed: 'Provide dates of employment',
          },
          position: {
            label: 'Position',
            help: {
              title: 'Need help with position title?',
              message: 'Provide the position title',
              note: '',
            },
          },
          supervisor: {
            label: 'Supervisor',
            help: {
              title: 'Need help with the supervisor name?',
              message: 'Provide the supervisor name',
              note: '',
            },
          },
          datesEmployed: {
            help: {
              title: 'Need help with the dates of employment?',
              message: 'Provide dates of employment',
              note: '',
            },
          },
        },
        para: {
          additionalActivity:
            'Provide additional periods of activity if you worked for this employer on more than one occasion at the same physical location (for example, if you worked at XY Plumbing in Denver, CO, during 3 separate periods of time you would enter information concerning the most recent period of employment above, and provide dates, position titles, and supervisors for the two previous periods of employment as entries below).',
        },
      },
      unemployment: {
        notApplicable: 'Not Applicable',

        heading: {
          militaryAddress: 'Does your verifier have an APO/FPO address?', // add back "unemploment verifier"  later did this as a temp fix for the label
          reference:
            'Provide the name of someone who can verify your unemployment activities and means of support',
        },
      },
      other: {
        heading: {
          employer: 'Provide the name of your employer',
          title: 'Provide the most recent position title',
          status: 'Select the employment status for this position',
          address: 'Provide the address of employer',
          telephone: 'Provide telephone number',
          reference:
            'Provide the name of someone who can verify your unemployment activities and means of support',
          hasDifferentPhysical: 'Is or was your work address different than this employer\'s address? (Your work address is where you physically work or worked.)',
          physicalAddress:
            'Is or was your work address in the U.S.? (Your work address is where you physically work or worked.)',
          supervisorPhysicalAddress:
            'Is/was your supervisors physical work address different than your Job Location?',
          additionalActivity: 'Additional periods of activity with this employer',
        },
        activity: {
          other: {
            help: {
              title: 'Need help with employment activity?',
              message: 'Please explain the type of employment activity',
              note: '',
            },
          },
        },
        employer: {
          label: 'Employer name',
          help: {
            title: 'Need help with the employer name?',
            message: 'Provide the name of your employer',
            note: '',
          },
        },
        title: {
          label: 'Title',
          help: {
            title: 'Need help with the position title?',
            message: 'Provide the name of your position title',
            note: '',
          },
        },
        status: {
          help: {
            title: 'Need help with the employment status?',
            message: 'Select the employment status',
            note: '',
          },
          fullTime: 'Full-time',
          partTime: 'Part-time',
        },
        address: {
          label: 'This address is',
          help: {
            title: 'Acronyms:',
            message: 'APO - Army Post Office, FPO - Fleet Post Office.',
            note: '',
          },
        },
        telephone: {
          label: '',
          help: {
            title: 'Need help with the telephone number?',
            message: 'Provide the telephone number',
            note: '',
          },
        },
        physicalAddress: {
          help: {
            title: 'Are/were you working from another location?',
            message:
              'Are/were you physically working from an different location than your employer\'s address? If so answer "Yes".',
            note: '',
          },
          address: {
            label: 'This address is',
          },
          heading: {
            telephone: 'Provide telephone number',
            address: 'Provide the address of physical location',
          },
        },
        additionalActivity: {
          help: {
            title: 'Need help with any additional periods of activity?',
            message: 'Do you have any additional periods of activity to add?',
            note: '',
          },
          label: 'Do you have any additional periods of activity to add?',
          collection: {
            append: 'Add additional periods',
          },
          heading: {
            position: 'Provide position title',
            supervisor: 'Provide supervisor',
            datesEmployed: 'Provide dates of employment',
          },
          position: {
            label: 'Position',
            help: {
              title: 'Need help with the position title?',
              message: 'Provide the position title',
              note: '',
            },
          },
          supervisor: {
            label: 'Supervisor',
            help: {
              title: 'Need help with the supervisor?',
              message: 'Provide the supervisor name',
              note: '',
            },
          },
          datesEmployed: {
            help: {
              title: 'Need help with the dates of employment?',
              message: 'Provide dates of employment',
              note: '',
            },
          },
        },
        para: {
          additionalActivity:
            'Provide additional periods of activity if you worked for this employer on more than one occasion at the same physical location (for example, if you worked at XY Plumbing in Denver, CO, during 3 separate periods of time you would enter information concerning the most recent period of employment above, and provide dates, position titles, and supervisors for the two previous periods of employment as entries below).',
        },
      },
      label: {
        referenceLocationComments: 'Optional Comments',
        unemploymentComments: 'Optional Comments',
        militaryEmploymentComments: 'Optional Comments',
        nonmilitaryEmploymentComments: 'Optional Comments',
        employmentActivityComments: 'Optional Comments',
        selfEmploymentComments: 'Optional Comments',
        employmentRecordComments: 'Optional Comments',
        summaryComments: 'Optional Summary Comments',
        supervisorcomments: 'Optional Comments',
        reasonLeftAnswerComments: 'Optional Comments',
      },
    },
    education: {
      title: '',
      info:
        'This section asks for information regarding schools you have attended in the past five years and whether you received a degree or diploma. (Only report information prior to your 18th birthday if necessary to report a minimum of 2 years of information.) This question includes all types of schools -- both in-person and distance learning. Distance learning includes by correspondence, extension (such as foreign exchange program sponsored by a college or university), online, and other similar distance learning education. For assistance determining school addresses refer to [http://ope.ed.gov/accreditation/search.asp](http://ope.ed.gov/accreditation/search.asp)',
      info2: 'If your attendance was not consecutive, please report each period of attendance separately. If the institution is no longer in business please check "\\[\\] School no longer in business" box. However, please provide the address where it was located and all pertinent information asked below to the best of your ability.',
      summary: {
        title: 'Section 06: Education - Recent',
        degreeTitle: 'Section 06: Education - Historical Degrees',
        schools: 'Schools attended',
        diplomas: 'Degrees/Diplomas earned',
        svgAlt: 'Years covered for schools attended',
      },
      collection: {
        caption: 'Section 06: Where you went to school',
        school: {
          summary: {
            title: 'Summary of recent education',
            degreeTitle: 'Summary of historical degrees',
            item: 'School',
            unknown: 'Provide your education details',
            incomplete: "This education's information is incomplete",
            item2: 'Diploma',
          },
          append: 'Add another school',
          degreeAppend: 'Add another school',
          appendTitle:
            'Do you have another school to report within the past 5 years?  (Only report information prior to your 18th birthday if necessary to report a minimum of 2 years of information.)',
          degreeAppendTitle:
            'Do you have another degree or diploma to report? (You must report all degrees and diplomas you have received; however, you do not need to report a High School diploma if you have achieved a higher degree.)',
        },
      },
      diploma: {
        summary: {
          title: 'Summary of degrees/diplomas',
          item: 'Degree',
          unknown: 'Provide your degree/diploma details',
        },
        append: 'Add another diploma/degree',
      },
      heading: {
        done: "Done! Now let's add more",
        exiting: 'Before you leave this section',
        degrees: 'Degrees/diplomas',
        degree: 'Did you receive a degree or diploma from this school?',
        degreeTail: 'Do you have another degree/diploma from this school to add?',
        details: 'Enter your school information',
        dates: 'When did you attend this school?',
        name: 'What is the name of the school? (Do not use abbreviations or acronyms.)',
        degreeSchoolName: 'What is the name of the school that awarded you ,this degree or diploma? (Do not use abbreviations or acronyms.)',
        address: 'Provide the street address of the school',
        physicalLocations: 'Is or was the physical location different than the school address entered above, such as at another campus or other location?',
        physicalLocationsAppend: 'Do you have another instance to report where the physical location you attended school is different than the school address entered above (such as at another campus or other location.)',
        comments:
          'If you need to provide additional comments about this information enter them below',
        type: 'What type of school is this?',
        typeOtherExplanation: 'Please Explain',
        reference: 'List a counselor, instructor, student, or other person who knew you at this school. For distance learning list someone who knew you received this education. Do not list your spouse; partner from a civil union, domestic partnership, or common law marriage; person you are in a committed, spouse-like relationship with; or other relatives.',
        referenceType: 'What is your relationship with this individual? (Select all that apply.)',
        referenceTypeOther: 'Please explain.',
        diploma: 'What type of degree or diploma did you receive?',
        date: 'When were you awarded this degree or diploma?',
        learningExperience: 'Which best describes your learning experience at this type of school?',
        learningExperienceOtherExplanation: 'Please explain.',
      },
      verifier: {
        name: 'List a counselor, instructor, student, or other person who knew you at this school. For distance learning list someone who knew you received this education. Do not list your spouse; partner from a civil union, domestic partnership, or common law marriage; person you are in a committed, spouse-like relationship with; or other relatives.',
        address: 'Do they currently live or work in the U.S.?',
        addressDomesticTitle: 'What is the address?',
        addressForeignTitle: 'Where is the location?',
        relationship: 'What is your relationship with this individual? (Select all that apply.)',
        relationshipOtherExplanation: 'Please explain'

      },
      para: {
        exiting: '',
        reference:
          'List a counselor, instructor, student, or other person who knew you at this school. For distance learning list someone who knew you received this education. Do not list your spouse; partner from a civil union, domestic partnership, or common law marriage; person you are in a committed, spouse-like relationship with; or other relatives',
      },
      label: {
        address: 'Is this school in the U.S.? (For distance-learning schools use the address where your school records are kept.)',
        addressDomesticTitle: 'What is this school\'s address?',
        addressForeignTitle: 'Where is this school located?',
        physicalAddress: 'Is or was your school physical address in the U.S.? (Your school address is where you physically attend or attended.)',
        addressLink:
          'For correspondence/distance/extension/online schools, provide the address where the records are maintained. For assistance determining the school address, refer to [https://ope.ed.gov/accreditation/search](https://ope.ed.gov/accreditation/search).',
        attendance: 'Have you attended any schools in the past five years? (Only report information prior to your 18th birthday if necessary to report a minimum of 2 years of information.)',
        dates:
          'You are not required to list temporary locations of less than 90 days that did not serve as your permanent or mailing address.',
        degree5: 'Did you receive another degree or diploma over five years ago?',

        name: 'School name',
        outOfBusiness: 'School no longer in business',
        learningExperience: {
          combination: 'Combination of in-person and not in-person',
          inPerson: 'In-person',
          notInPerson: 'Not in-person (for example, correspondence, online, extension, other similar distance learning education)',
          other: 'Other',
        },
        type: {
          college: 'College/University/Military Academy',
          highschool: 'High School',
          other: 'Other',
          vocational: 'Vocational/Technical/Trade School',
        },
        diploma: {
          received: 'What type of degree or diploma did you receive?',
          highschool: 'High School diploma',
          associate: "Associate's degree",
          bachelor: "Bachelor's degree",
          master: "Master's degree",
          doctorate: 'Doctoral degree',
          professional: 'Professional degree (for example, MD, DVM, JD)',
          other: 'Other',
          otherDiploma: 'Please Explain',
        },
        comments: 'Optional Comments',
        attendedcomments: 'Optional Comments',
        diplomasanswercomments: 'Optional Comments',
        degreesawardedcomments: 'Optional Comments',
        summarycomments: 'Optional Summary Comments',
        referencecomments: 'Optional Comments',
        hasdegreecomments: 'Optional Comments',
      },
      help: {
        attendance: {
          title: 'Including all schools you attended',
          message:
            'If within the last {{years}} years you have attended a high school, college, vocational, or correspondence course answer "Yes".',
          note: '',
        },
        degree10: {
          title: 'Any degree/diploma you have received in your life',
          message: 'If you have ever earned a degree or diploma from any point in your life answer "Yes".',
          note: '',
        },
        dates: {
          title: 'Estimate the date if unsure',
          message:
            'If you are not sure of the exact dates give us your best guess and check the "Estimated" checkbox.',
          note: '',
        },
        address: {
          title:
            'For correspondence/distance/extension/online schools, provide the address where the records are maintained',
          message:
            'For assistance determining the school address, refer to [https://ope.ed.gov/accreditation/search](https://ope.ed.gov/accreditation/search).',
          note:
            'Acronyms: APO - Army Post Office, FPO - Fleet Post Office.',
        },
        type: {
          title: 'Need help with the school options?',
          message: 'Select the most appropriate option to describe your school',
          note: '',
        },
        comments: {
          title: 'Need help providing more information?',
          message:
            'If you need to provide any additional comments about this information enter them below',
          note: '',
        },
        degree: {
          title: 'Need help with a degree or diploma?',
          message:
            'If you have received one or more degrees or diplomas from this school please provide the required information',
          note: '',
        },
        diploma: {
          title: 'Select the most appropriate degree or diploma received',
          message: 'If your option isn\'t listed select "Other" then provide it.',
          note: '',
        },
        date: {
          title: 'Estimate the date if unsure',
          message:
            'If you are not sure of the exact date give us your best guess and check the "Estimated" checkbox.',
          note: '',
        },
      },
      error: {
        afterDuration: {
          title: 'There is a problem with the date',
          message: 'You indicated that you did not have any education within this education date range on a previous question.  Please check that the dates entered are correct, and adjust your response to the previous question if they are.',
        },
      },
    },
    federal: {
      heading: {
        branch:
          'Other than employment listed in section 7, have you worked for the U.S. Federal Government outside of the past five years?',
        dates: 'When did you work for this federal agency?',
        name: 'What federal agency did you work for?',
        position: 'Provide your position title',
        address: 'Provide the location of the agency',
        comments: 'Optional Comments',
        reasonLeft: 'Why did you leave this Federal employment?',
        additionalEmployment: 'Do you have another period of federal employment with this federal agency to report?'
      },
      comments: 'Optional Comments',
      summarycomments: 'Optional Summary Comments',
      info: 'This section asks for information regarding former Federal civilian employment that is outside of the past five years and not reported in section 7. Do not repeat employment that occurred in the past five years that you reported in section 7. This information is requested to determine the reason you left the former federal employment and whether you had any conduct issues or any disciplinary actions. This section does not apply to military service.',
      help: {
        branch: {
          title: 'List all federal service even if older than {{years}} years',
          message: 'Inclue all former federal service at any point in your life.',
          note: '',
        },
        dates: {
          title: 'Estimate the date if unsure',
          message:
            'If you are not sure of the exact dates give us your best guess and check the "Estimated" checkbox.',
          note: '',
        },
        name: {
          title: 'Need help with the agency name?',
          message: 'The name of the federal service',
          note: '',
        },
        position: {
          title: 'Need help with the position title?',
          message: 'The most recent position title during this employment.',
          note: '',
        },
        address: {
          title: 'Try looking up the agency name, this could help you find the address',
          message:
            'Acronyms: APO - Army Post Office, FPO - Fleet Post Office.',
          note: '',
        },
      },
      name: {
        title: 'Need help with the agency name?',
        message: 'The name of the federal service',
        note: '',
      },
      position: {
        title: 'Need help with the position title?',
        message: 'The most recent position title during this employment.',
        note: '',
      },
      address: {
        title: 'Try looking up the agency name, this could help you find the address',
        message:
          'Acronyms: APO - Army Post Office, FPO - Fleet Post Office.',
        note: '',
      },
      collection: {
        summary: {
          title: 'Summary of former federal service',
          item: 'Federal service',
          present: 'Now',
          nodates: 'NA',
          unknown: 'Provide federal service below',
        },
        appendTitle:
          'Do you have another period of federal employment to report?',
        append: 'Add another former federal service',
      },
    },
  },
  intro: {
    title: 'Your history',
    body:
      'You will be asked questions about your history and to provide details if necessary. This section includes where you have lived, where you have worked, and where you went to school.',
  },
  tour: {
    para: 'Take a guided tour through the section',
  },
  review: {
    title: 'Full section view',
    para: 'View all the sections associated with your history at once',
    button: 'Show me the full section',
  },
  section: {
    name: 'Your history',
  },
  subsection: {
    intro: 'Introduction',
    residence: 'Where you have lived',
    employment: 'Employment activities',
    education: 'Where you went to school',
    federal: 'Former federal service',
    review: 'Review',
  },
  destination: {
    intro: 'History intro',
    review: 'Review your history',
    timeline: 'Timeline',
    residence: 'Places you lived',
    employment: 'Employment history',
    education: 'Schools & diplomas',
    federal: 'Former federal service',
  },
  residence: {
    title: 'Where you have lived',
    info:
      'List the places where you have lived beginning with your present residence and working back {{years}} years.',
    info2: 'Residences for the entire period must be accounted for without breaks.',
    info3a:
      ' - **Indicate the actual physical location of your residence**, not a Post Office box or address where you did not physically reside.',
    info3b:
      ' - **If you split your time between one or more residences during a time period**, you must list all residences.',
    info3c:
      ' - **Do not list residences before your 18th birthday** unless to provide a minimum of 2 years residence history.',
    info3d:
      ' - **You are not required to list temporary locations of less than 90 days** that did not serve as your permanent or mailing address.',
    infoSF852013: 'All periods must be accounted for in your list. Be sure to indicate the actual physical location of your residence: do not use a post office box as an address, do not list a permanent address when you were actually living at a school address, etc. Be sure to specify your location as closely as possible: for example, do not list only your base or ship, list your barracks number or home port. You may omit temporary military duty locations under 90 days (list your permanent address instead), and you should use your APO/FPO address if you lived overseas.',
    summary: {
      title: 'Where you have lived',
      unit: 'Years covered',
      svgAlt: 'Years covered for locations you have lived',
    },
    comments: 'Optional Summary Comments',
    collection: {
      caption: 'Where you have lived',
      summary: {
        title: 'Summary of places you have lived',
        item: 'Address',
        unknown: 'Provide residence details',
        incomplete: "This residence's information is incomplete",
        item2: 'Person',
      },
      append: 'Add another residence',
      appendTitle: 'Do you have an additional residence to report?',
    },
    gap: {
      title: 'Residence gap',
      para:
        'There is a gap in your residence history. The entire {{years}} year period must be covered with no gaps',
      btnText: 'Add an address',
    },
    heading: {
      done: "Done! Now let's add more",
      exiting: 'Before you leave this section',
      details: 'Enter your residence information',
      dates: 'Provide dates of residence',
      address: 'Provide the street address',
      comments:
        'If you need to provide additional comments about this information enter them below',
      role: 'Is/was this residence',
      reference: 'Add a person that knows you',
    },
    para: {
      done: 'Use the button below to save your history entry and start another.',
      exiting: [
        '**The full {{years}} year period of residence history is not covered.** Your {{formName}} cannot be submitted until all {{years}} years are covered with no gaps.',
        '',
        '',
        'We will mark the gaps and highlight them for you when you come back.',
      ],
      details:
        'Indicate the actual physical location of your residence, not a Post Office box or address where you did not physically reside. If you split your time between one or more residences during a time period, you must list all residences. Do not list residences before your 18th birthday unless to provide a minimum of 2 years residence history.',
      reference:
        'For any address in the last 3 years, provide a person who knew you at that address and who preferably still lives in that area. Do not list someone who knew you well for any residence you had more than 3 years ago. Do not list your spouse, cohabitant or any other relative as the verifier for a period of residence.',
    },
    label: {
      dates:
        'You are not required to list temporary locations of less than 90 days that did not serve as your permanent or mailing address.',
      address: 'This address is',
      role: {
        owned: 'Owned by you',
        rented: 'Rented or leased by you',
        military: 'Military housing',
        other: 'Other',
        explanation: 'Please provide an explanation',
      },
      comments: 'Optional Comments',
      referencecomments: 'Optional Comments',
    },
    help: {
      dates: {
        title: 'Estimate the date if unsure',
        message:
          'If you are not sure of the exact dates give us your best guess and check the "Estimated" checkbox.',
        note: '',
      },
      address: {
        title: 'Acronyms:',
        message: 'APO - Army Post Office, FPO - Fleet Post Office.',
        note: '',
      },
      role: {
        title: 'Need help with the role?',
        message: 'Provide your role at this residence as closely as possible',
        note: '',
      },
      comments: {
        title: 'Need help providing additional information?',
        message:
          'If you need to provide any additional comments about this information enter them below',
        note: '',
      },
    },
  },
  employment: {
    summary: {
      title: 'Employment activities',
      unit: 'Years covered',
      svgAlt: 'Years covered for your employment activities',
    },
    gap: {
      title: 'Employment gap',
      para:
        'There is a gap in your employment. The entire {{years}} year period must be covered with no gaps',
      btnText: 'Add an employer',
    },
    heading: {
      employment: 'List where you have worked',
      exiting: 'Before you leave this section',
    },
    para: {
      exiting: [
        '**The full {{years}} year period of employment history is not covered.** Your {{formName}} cannot be submitted until all {{years}} years are covered with no gaps.',
        '',
        '',
        'We will mark the gaps and highlight them for you when you come back.',
      ],
      employment:
        'List all of your employment activities, including unemployment and self-employment, beginning with the present and working back {{years}} years. The entire period must be accounted for without breaks. If the employment activity was military duty, list separate employment activity periods to show each change of military duty station.\n\n Provide separate entries for employment activities with the same employer but having different physical addresses.',
      employment2:
        'Do not list employment before your 18th birthday unless to provide a minimum of 2 years employment history.',
      employmentSF852013:
        'Provide a detailed entry for each of your employment activities for the last 5 years. You should list all full-time work, part-time work, military service, temporary military duty locations over 90 days, self-employment, other paid work, and all periods of unemployment. The entire 5-year period must be accounted for without breaks, but you need not list employments before your 16th birthday.'
    },
    errors: {
      duplicateListItems: {
        title: 'Resolve errors above',
      }
    },
    default: {
      noDate: {
        label: 'NA',
      },
      collection: {
        caption: 'Employment activities',
        append: 'Add another employer',
        appendTitle: 'Do you have an additional employment activity to enter?',
        summary: {
          title: 'Summary of your work history',
          employer: 'Employer',
          incomplete: "This employer's information is incomplete",
          unknown: 'Provide employer details',
          item2: 'Title',
        },
      },
      employmentRecord: {
        title:
          'Have any of the following happened to you in the last {{yearsString}} ({{years}}) years at employment activities that you have not previously listed?',
        list: `* Fired from a job?
* Quit a job after being told you would be fired?
* Have you left a job by mutual agreement following charges or allegations of misconduct?
* Left a job by mutual agreement following notice of unsatisfactory performance?
* Received a written warning, been officially reprimanded, suspended, or disciplined for misconduct in the workplace, such as violation of security policy?`,
        para:
          'If you answer "Yes", you will be required to add an additional employment record above.',
      },
      activity: {
        title: 'Government employment',
        help: {
          title: 'Specifics:',
          message:
            'Non-government employment represents all employment outside of the government excluding self-employment. If you were self employed, please choose self-employment. ',
          note: '',
        },
        other: {
          label: 'Explanation for other',
          help: {
            title: '',
            message: '',
            note: '',
          },
        },
        type: {
          activeMilitary: 'Active military duty station',
          nationalGuard: 'National Guard/Reserve',
          usphs: 'USPHS Commissioned Corps',
          otherFederal: 'Other federal employment',
          stateGovernment: 'State Government (Non-Federal employment)',
          federalContractor: 'Federal contractor',
          nonGovernment: 'Non-government employment (excluding self-employment)',
          selfEmployment: 'Self-employment',
          unemployment: 'Unemployment',
          other: 'Other',
          otherEmployment: 'Other employment',
        },
      },
      reasonDescription: {
        title: 'Reason for leaving employment',
        message: 'Explain why you left your last employment',
      },
      left: {
        title: 'Provide the reason for leaving the employment activity',
        branch:
          'For this employment have any of the following happened to you in the last {{yearsString}} ({{years}}) years?',
        append:
          'In the last {{yearsString}} ({{years}}) years do you have another reason for leaving to report for this employment?',
        list: [
          '- Fired',
          '- Quit after being told you would be fired',
          '- Left by mutual agreement following charges or allegations of misconduct',
          '- Left by mutual agreement following notice of unsatisfactory performance',
        ],
        comments: 'Provide any additional comments for why you left this employment activity',
        severanceTypeComments: 'Optional Comments',
        optionalComments: 'Optional Comments',
        reasonLeftComments: 'Optional Comments',
        fired: {
          option: 'Fired',
          text: 'Provide the reason for being fired',
          date: 'Provide the date you were fired',
        },
        quit: {
          option: 'Quit',
          text: 'Provide the reason for quitting',
          date: 'Provide the date you quit after being told you would be fired',
        },
        charges: {
          option: 'Misconduct',
          text: 'Provide the charges or allegations of misconduct',
          date: 'Provide the date you left following the charges or allegations of misconduct',
        },
        performance: {
          option: 'Unsatisfactory performance',
          text: 'Provide the reason(s) for unsatisfactory performance',
          date:
            'Provide the date you left by mutual agreement following a notice of unsatisfactory performance',
        },
      },
      reprimand: {
        label:
          'For this employment, in the last {{yearsString}} ({{years}}) years have you received a written warning, been officially reprimanded, suspended, or disciplined for misconduct in the workplace, such as a violation of security policy?',
        append: 'Do you have another instance of discipline or a warning to provide?',
        description: {
          label: 'Provide the reason(s) for being warned, reprimanded, suspended or disciplined',
        },
        date: {
          label:
            'Provide the month and year you were warned, reprimanded, suspended or disciplined',
        },
        help: {
          title: 'Have you received a written warning',
          message:
            'Explain if you have you received a written warning, been officially reprimanded, suspended, or disciplined for misconduct in the workplace, such as a violation of security policy',
        },
        ReprimandComments: 'Optional Comments',
        ReprimandAnswerComments: 'Optional Comments',
        Comments: 'Optional Comments',
      },
      datesEmployed: {
        help: {
          title: 'Estimate the date if unsure',
          message:
            'If you are not sure of the exact dates give us your best guess and check the "Estimated" checkbox.',
          note: '',
        },
      },
      address: {
        label: 'This address is',
        help: {
          title: 'Acronyms:',
          message: 'APO - Army Post Office, FPO - Fleet Post Office.',
          note: '',
        },
      },
      status: {
        help: {
          title: 'Need help with the employment status?',
          message: 'Select the employment status',
          note: '',
        },
        fullTime: 'Full-time',
        partTime: 'Part-time',
      },
      telephone: {
        label: '',
        help: {
          title: 'Need help with the telephone number?',
          message: 'Provide the telephone number',
          note: '',
        },
      },
      title: {
        label: 'Title',
        help: {
          title: 'Need help with the position title?',
          message: 'Provide the name of your position title',
          note: '',
        },
      },
      employer: {
        label: 'Employer name',
        help: {
          title: 'Need help with the employer name?',
          message: 'Provide the name of your employer',
          note: '',
        },
      },
      physicalAddress: {
        help: {
          title: 'Are/were you working from another location?',
          message:
            'Are/were you physically working from an different location than your employer\'s address? If so answer "Yes".',
          note: '',
        },
        address: {
          label: 'This address is',
          help: {
            title: 'Acronyms:',
            message:
              'APO - Army Post Office, FPO - Fleet Post Office.',
            note: '',
          },
        },
        heading: {
          telephone: 'Provide telephone number',
          address: 'Provide the work address where you are/were physically located',
        },
        answercomments: 'Optional Comments',
        addresscomments: 'Optional Comments',
      },
      additionalActivity: {
        help: {
          title: 'Need help with any additional periods of activity?',
          message: 'Do you have any additional periods of activity to add?',
          note: '',
        },
        label: 'Do you have any additional periods of activity to add?',
        collection: {
          append: 'Add additional periods',
        },
        heading: {
          position: 'Provide position title',
          supervisor: 'Provide supervisor',
          datesEmployed: 'Dates of employment',
        },
        position: {
          label: 'Position title',
          help: {
            title: 'Need help with the position title?',
            message: 'Provide the position title',
            note: '',
          },
        },
        supervisor: {
          label: 'Supervisor',
          help: {
            title: 'Need help with the supervisor?',
            message: 'Provide the supervisor name',
            note: '',
          },
        },
        datesEmployed: {
          help: {
            title: 'Need help with the dates of employment?',
            message:
              'If you are not sure of the exact dates give us your best guess and check the "Estimated" checkbox.',
            note: '',
          },
        },
      },
      supervisor: {
        name: {
          label: 'Supervisor name',
          help: {
            title: 'Need help with the supervisor name?',
            message: 'Provide the name of this supervisor',
            note: '',
          },
        },
        title: {
          label: 'Supervisor position title',
          help: {
            title: 'Need help with the position title?',
            message: 'Provide the position title of this supervisor',
            note: '',
          },
        },
        email: {
          label: 'Supervisor email',
          help: {
            title: 'Need help with the email?',
            message: 'Provide the email of this supervisor',
            note: '',
          },
        },
        hasdifferentaddress: {
          label: "Is/was your supervisor's physical work address different than your Job Location?",
          help: {
            title: 'Is/was your supervisor working from another location?',
            message:
              'Is/was your supervisor physically working from a different location than your employer\'s address? If so answer "Yes".',
            note: '',
          },
        },
        address: {
          label: 'This address is',
          help: {
            title: 'Tell us where your supervisor works/worked',
            message: "Provide the physical address of this supervisor's work location.",
            note: '',
          },
        },
        telephone: {
          help: {
            title: 'Need help with the telephone number?',
            message: 'Provide the telephone number for this supervisor',
            note: '',
          },
        },
        heading: {
          name: 'Provide the name of your supervisor',
          title: 'Provide the rank/position title of your supervisor',
          titleNonMilitary: 'Provide the position title of your supervisor',
          email: 'Provide the email address of your supervisor',
          address: 'Provide the physical work location of your supervisor',
          telephone: 'Provide the telephone number for this supervisor',
        },
      },
      heading: {
        employment: 'List where you have worked',
        done: "Done! Now let's add more",
        exiting: 'Before you leave this section',
        activity: 'Select your employment activity',
        datesEmployed: 'Provide dates of employment',
        employer: 'Provide the name of your employer',
        title: 'Provide the most recent position title',
        reference: 'Provide a reference',
        status: 'Select the employment status for this position',
        address: 'Provide the address of employer',
        supervisor: 'Your Supervisor',
        telephone: 'Provide telephone number',
        physicalAddress:
          "Is/was your physical work address different than your employer's address?",
        additionalActivity: 'Additional periods of activity with this employer',
      },
      para: {
        additionalActivity:
          'Provide additional periods of activity if you worked for this employer on more than one occasion at the same physical location (for example, if you worked at XY Plumbing in Denver, CO, during 3 separate periods of time you would enter information concerning the most recent period of employment above, and provide dates, position titles, and supervisors for the two previous periods of employment as entries below).',
      },
    },
    usmilitary: {
      address: {
        label: 'This address is',
      },
    },
    activemilitary: {
      heading: {
        title: 'Provide your most recent rank/position title',
        status: 'Select the employment status for this position',
        address: 'Provide address of duty station',
        telephone: 'Provide telephone number',
        supervisor: 'Your Supervisor',
        reference: 'Provide a reference',
        physicalAddress:
          "Is/was your physical work address different than your employer's address?",
        supervisorPhysicalAddress:
          'Is/was your supervisors physical work address different than your Job Location?',
        additionalActivity: 'Additional periods of activity with this employer',
        dutyStation: 'Provide your assigned duty station during this period',
      },
      title: {
        label: 'Title',
        help: {
          title: 'Need help with the position title?',
          message: 'Provide the name of your position title',
          note: '',
        },
      },
      status: {
        help: {
          title: 'Need help with the employment status?',
          message: 'Select the employment status',
          note: '',
        },
      },
      address: {
        label: 'This address is',
        help: {
          title: 'Acronyms:',
          message: 'APO - Army Post Office, FPO - Fleet Post Office.',
          note: '',
        },
      },
      telephone: {
        label: '',
        help: {
          title: 'Need help with the telephone number?',
          message: 'Provide the telephone number',
          note: '',
        },
      },
      supervisor: {
        name: {
          label: 'Supervisor name',
          help: {
            title: 'Need help with the supervisor name?',
            message: 'Provide the name of this supervisor',
            note: '',
          },
        },
        title: {
          label: 'Supervisor position title',
          help: {
            title: 'Need help with the position title?',
            message: 'Provide the position title of this supervisor',
            note: '',
          },
        },
        email: {
          label: 'Supervisor email',
          help: {
            title: 'Provide the email of this supervisor',
            message: 'Only provide an active email address where this supervisor can be reached.',
            note: '',
          },
        },
        address: {
          label: 'This address is',
          help: {
            title: 'Acronyms:',
            message:
              'APO - Army Post Office, FPO - Fleet Post Office.',
            note: '',
          },
        },
        telephone: {
          help: {
            title: 'Need help with the telephone number?',
            message: 'Provide the telephone number for this supervisor',
            note: '',
          },
        },
        heading: {
          name: 'Provide the name of your supervisor',
          title: 'Provide the position title of your supervisor',
          email: 'Provide the email address of your supervisor',
          address: 'Provide the physical work location of your supervisor',
          telephone: 'Provide the telephone number for this supervisor',
        },
      },
      additionalActivity: {
        help: {
          title: 'Need help with additional periods of activity?',
          message: 'Do you have any additional periods of activity to add?',
          note: '',
        },
        label: 'Do you have any additional periods of activity to add?',
        collection: {
          append: 'Add additional periods',
        },
        heading: {
          position: 'Provide position title',
          supervisor: 'Provide supervisor',
          datesEmployed: 'Provide dates of employment',
        },
        position: {
          label: 'Position',
          help: {
            title: 'Need help with the position title?',
            message: 'Provide the position title',
            note: '',
          },
        },
        supervisor: {
          label: 'Supervisor',
          help: {
            title: 'Need help with the name?',
            message: 'Provide the supervisor name',
            note: '',
          },
        },
        datesEmployed: {
          help: {
            title: 'Need help with the dates of employment?',
            message: 'Provide dates of employment',
            note: '',
          },
        },
      },
      dutyStation: {
        label: 'Duty station',
      },
      para: {
        additionalActivity:
          'Provide additional periods of activity if you worked for this employer on more than one occasion at the same physical location (for example, if you worked at XY Plumbing in Denver, CO, during 3 separate periods of time you would enter information concerning the most recent period of employment above, and provide dates, position titles, and supervisors for the two previous periods of employment as entries below).',
      },
    },
    nationalguard: {
      heading: {
        title: 'Provide your most recent rank/position title',
        status: 'Select the employment status for this position',
        address: 'Provide address of duty station',
        telephone: 'Provide telephone number',
        supervisor: 'Your Supervisor',
        reference: 'Provide a reference',
        physicalAddress:
          "Is/was your physical work address different than your employer's address?",
        additionalActivity: 'Additional periods of activity with this employer',
        dutyStation: 'Provide your assigned duty station during this period',
      },
      title: {
        label: 'Title',
        help: {
          title: 'Need help with the rank/position title?',
          message: 'Provide your most recent rank/position title',
          note: '',
        },
      },
      status: {
        help: {
          title: 'Need help with the employment status?',
          message: 'Select the employment status',
          note: '',
        },
      },
      address: {
        label: 'This address is',
        help: {
          title: 'Acronyms:',
          message: 'APO - Army Post Office, FPO - Fleet Post Office.',
          note: '',
        },
      },
      telephone: {
        label: '',
        help: {
          title: 'Need help with the phone number?',
          message: 'Provide the telephone number',
          note: '',
        },
      },
      supervisor: {
        name: {
          label: 'Supervisor name',
          help: {
            title: 'Need help with the supervisor name?',
            message: 'Provide the name of this supervisor',
            note: '',
          },
        },
        title: {
          label: 'Supervisor position title',
          help: {
            title: 'Need help with the position title?',
            message: 'Provide the position title of this supervisor',
            note: '',
          },
        },
        email: {
          label: 'Supervisor email',
          help: {
            title: 'Need help with the email address?',
            message: 'Provide the email of this supervisor',
            note: '',
          },
        },
        address: {
          label: 'This address is',
          help: {
            title: 'Tell us where your supervisor works/worked',
            message: "Provide the physical address of this supervisor's work location.",
            note: '',
          },
        },
        telephone: {
          help: {
            title: 'Need help with the telephone number?',
            message: 'Provide the telephone number for this supervisor',
            note: '',
          },
        },
        heading: {
          name: 'Provide the name of your supervisor',
          title: 'Provide the position title of your supervisor',
          email: 'Provide the email address of your supervisor',
          address: 'Provide the physical work location of your supervisor',
          telephone: 'Provide the telephone number for this supervisor',
        },
      },
      additionalActivity: {
        help: {
          title: 'Need help with additional periods of activity?',
          message: 'Do you have any additional periods of activity to add?',
          note: '',
        },
        label: 'Do you have any additional periods of activity to add?',
        collection: {
          append: 'Add additional periods',
        },
        heading: {
          position: 'Provide position title',
          supervisor: 'Provide supervisor',
          datesEmployed: 'Provide dates of employment',
        },
        position: {
          label: 'Position',
          help: {
            title: 'Need help with the position title?',
            message: 'Provide the position title',
            note: '',
          },
        },
        supervisor: {
          label: 'Supervisor',
          help: {
            title: 'Need help with the supervisor name?',
            message: 'Provide the supervisor name',
            note: '',
          },
        },
        datesEmployed: {
          help: {
            title: 'Need help with the dates of employment?',
            message: 'Provide dates of employment',
            note: '',
          },
        },
      },
      dutyStation: {
        label: 'Duty station',
      },
      para: {
        additionalActivity:
          'Provide additional periods of activity if you worked for this employer on more than one occasion at the same physical location (for example, if you worked at XY Plumbing in Denver, CO, during 3 separate periods of time you would enter information concerning the most recent period of employment above, and provide dates, position titles, and supervisors for the two previous periods of employment as entries below).',
      },
    },
    usphs: {
      heading: {
        title: 'Provide your most recent rank/position title',
        status: 'Select the employment status for this position',
        address: 'Provide address of duty station',
        telephone: 'Provide telephone number',
        supervisor: 'Your Supervisor',
        reference: 'Provide a reference',
        physicalAddress:
          "Is/was your physical work address different than your employer's address?",
        additionalActivity: 'Additional periods of activity with this employer',
        dutyStation: 'Provide your assigned duty station during this period',
      },
      title: {
        label: 'Title',
        help: {
          title: 'Need help with the rank/position title?',
          message: 'Provide your most recent rank/position title',
          note: '',
        },
      },
      status: {
        help: {
          title: 'Need help with the employment status?',
          message: 'Select the employment status',
          note: '',
        },
      },
      address: {
        label: 'This address is',
        help: {
          title: 'Acronyms:',
          message: 'APO - Army Post Office, FPO - Fleet Post Office.',
          note: '',
        },
      },
      telephone: {
        label: '',
        help: {
          title: 'Need help with the telephone number?',
          message: 'Provide the telephone number',
          note: '',
        },
      },
      supervisor: {
        name: {
          label: 'Supervisor name',
          help: {
            title: 'Need help with the supervisor name?',
            message: 'Provide the name of this supervisor',
            note: '',
          },
        },
        title: {
          label: 'Supervisor position title',
          help: {
            title: 'Need help with the position title?',
            message: 'Provide the position title of this supervisor',
            note: '',
          },
        },
        email: {
          label: 'Supervisor email',
          help: {
            title: 'Need help with the email address?',
            message: 'Provide the email of this supervisor',
            note: '',
          },
        },
        address: {
          label: 'This address is',
          help: {
            title: 'Tell us where your supervisor works/worked',
            message: "Provide the physical address of this supervisor's work location.",
            note: '',
          },
        },
        telephone: {
          help: {
            title: 'Need help with the telephone number?',
            message: 'Provide the telephone number for this supervisor',
            note: '',
          },
        },
        heading: {
          name: 'Provide the name of your supervisor',
          title: 'Provide the position title of your supervisor',
          email: 'Provide the email address of your supervisor',
          address: 'Provide the physical work location of your supervisor',
          telephone: 'Provide the telephone number for this supervisor',
        },
      },
      additionalActivity: {
        help: {
          title: 'Need help with additional periods of activity?',
          message: 'Do you have any additional periods of activity to add?',
          note: '',
        },
        label: 'Do you have any additional periods of activity to add?',
        collection: {
          append: 'Add additional periods',
        },
        heading: {
          position: 'Provide position title',
          supervisor: 'Provide supervisor',
          datesEmployed: 'Provide dates of employment',
        },
        position: {
          label: 'Position',
          help: {
            title: 'Need help with the position title?',
            message: 'Provide the position title',
            note: '',
          },
        },
        supervisor: {
          label: 'Supervisor',
          help: {
            title: 'Need help with the supervisor name?',
            message: 'Provide the supervisor name',
            note: '',
          },
        },
        datesEmployed: {
          help: {
            title: 'Need help with the dates of employment?',
            message: 'Provide dates of employment',
            note: '',
          },
        },
      },
      dutyStation: {
        label: 'Duty station',
      },
      para: {
        additionalActivity:
          'Provide additional periods of activity if you worked for this employer on more than one occasion at the same physical location (for example, if you worked at XY Plumbing in Denver, CO, during 3 separate periods of time you would enter information concerning the most recent period of employment above, and provide dates, position titles, and supervisors for the two previous periods of employment as entries below).',
      },
    },
    otherfederal: {
      heading: {
        employer: 'Provide the name of your employer',
        title: 'Provide the most recent position title',
        status: 'Select the employment status for this position',
        address: 'Provide the address of employer',
        telephone: 'Provide telephone number',
        reference: 'Provide a reference',
        physicalAddress:
          "Is/was your physical work address different than your employer's address?",
        supervisorPhysicalAddress:
          'Is/was your supervisors physical work address different than your Job Location?',
        additionalActivity: 'Additional periods of activity with this employer',
      },
      para: {
        additionalActivity:
          'Provide additional periods of activity if you worked for this employer on more than one occasion at the same physical location (for example, if you worked at XY Plumbing in Denver, CO, during 3 separate periods of time you would enter information concerning the most recent period of employment above, and provide dates, position titles, and supervisors for the two previous periods of employment as entries below).',
      },
      employer: {
        label: 'Employer name',
        help: {
          title: 'Need help with the employer name?',
          message: 'Provide the name of your employer',
          note: '',
        },
      },
      title: {
        label: 'Title',
        help: {
          title: 'Need help with the position title?',
          message: 'Provide the name of your position title',
          note: '',
        },
      },
      status: {
        help: {
          title: 'Need help with the employment status?',
          message: 'Select the employment status',
          note: '',
        },
      },
      address: {
        label: 'This address is',
        help: {
          title: 'Acronyms:',
          message:
            'Acronyms: APO - Army Post Office, FPO - Fleet Post Office.',
          note: '',
        },
      },
      telephone: {
        label: '',
        help: {
          title: 'Need help with the telephone number?',
          message: 'Provide the telephone number',
          note: '',
        },
      },
      physicalAddress: {
        help: {
          title: 'Are/were you working from another location?',
          message:
            'Are/were you physically working from a different location than your employer\'s address? If so answer "Yes".',
          note: '',
        },
        address: {
          label: 'This address is',
        },
        heading: {
          telephone: 'Provide telephone number',
          address: 'Provide the address of physical location',
        },
      },
      additionalActivity: {
        help: {
          title: 'Need help with additional periods of activity?',
          message: 'Do you have any additional periods of activity to add?',
          note: '',
        },
        label: 'Do you have any additional periods of activity to add?',
        collection: {
          append: 'Add additional periods',
        },
        heading: {
          position: 'Provide position title',
          supervisor: 'Provide supervisor',
          datesEmployed: 'Provide dates of employment',
        },
        position: {
          label: 'Position',
          help: {
            title: 'Need help with the position title?',
            message: 'Provide the position title',
            note: '',
          },
        },
        supervisor: {
          label: 'Supervisor',
          help: {
            title: 'Need help with the supervisor name?',
            message: 'Provide the supervisor name',
            note: '',
          },
        },
        datesEmployed: {
          help: {
            title: 'Need help with the dates of employment?',
            message: 'Provide dates of employment',
            note: '',
          },
        },
      },
    },
    stategovernment: {
      heading: {
        employer: 'Provide the name of your employer',
        title: 'Provide the most recent position title',
        status: 'Select the employment status for this position',
        address: 'Provide the address of employer',
        telephone: 'Provide telephone number',
        reference: 'Provide a reference',
        physicalAddress:
          "Is/was your physical work address different than your employer's address?",
        supervisorPhysicalAddress:
          'Is/was your supervisors physical work address different than your Job Location?',
        additionalActivity: 'Additional periods of activity with this employer',
      },
      para: {
        additionalActivity:
          'Provide additional periods of activity if you worked for this employer on more than one occasion at the same physical location (for example, if you worked at XY Plumbing in Denver, CO, during 3 separate periods of time you would enter information concerning the most recent period of employment above, and provide dates, position titles, and supervisors for the two previous periods of employment as entries below).',
      },
      employer: {
        label: 'Employer name',
        help: {
          title: 'Need help with the employer name?',
          message: 'Provide the name of your employer',
          note: '',
        },
      },
      title: {
        label: 'Title',
        help: {
          title: 'Need help with the position title?',
          message: 'Provide the name of your position title',
          note: '',
        },
      },
      status: {
        help: {
          title: 'Need help with the employment status?',
          message: 'Select the employment status',
          note: '',
        },
      },
      address: {
        label: 'This address is',
        help: {
          title: 'Acronyms:',
          message: 'APO - Army Post Office, FPO - Fleet Post Office.',
          note: '',
        },
      },
      telephone: {
        label: '',
        help: {
          title: 'Need help with the telephone number?',
          message: 'Provide the telephone number',
          note: '',
        },
      },
      physicalAddress: {
        help: {
          title: 'Are/were you working from another location?',
          message:
            'Are/were you physically working from a different location than your employer\'s address? If so answer "Yes".',
          note: '',
        },
        address: {
          label: 'This address is',
        },
        heading: {
          telephone: 'Provide telephone number',
          address: 'Provide the address of physical location',
        },
      },
      additionalActivity: {
        help: {
          title: 'Need help with additional periods of activity?',
          message: 'Do you have any additional periods of activity to add?',
          note: '',
        },
        label: 'Do you have any additional periods of activity to add?',
        collection: {
          append: 'Add additional periods',
        },
        heading: {
          position: 'Provide position title',
          supervisor: 'Provide supervisor',
          datesEmployed: 'Provide dates of employment',
        },
        position: {
          label: 'Position',
          help: {
            title: 'Need help with the position title?',
            message: 'Provide the position title',
            note: '',
          },
        },
        supervisor: {
          label: 'Supervisor',
          help: {
            title: 'Need help with the supervisor name?',
            message: 'Provide the supervisor name',
            note: '',
          },
        },
        datesEmployed: {
          help: {
            title: 'Need help with the dates of employment?',
            message: 'Provide dates of employment',
            note: '',
          },
        },
      },
    },
    federalcontractor: {
      heading: {
        employer: 'Provide the name of your employer',
        title: 'Provide the most recent position title',
        status: 'Select the employment status for this position',
        address: 'Provide the address of employer',
        telephone: 'Provide telephone number',
        reference: 'Provide a reference',
        physicalAddress:
          "Is/was your physical work address different than your employer's address?",
        supervisorPhysicalAddress:
          'Is/was your supervisors physical work address different than your Job Location?',
        additionalActivity: 'Additional periods of activity with this employer',
      },
      para: {
        additionalActivity:
          'Provide additional periods of activity if you worked for this employer on more than one occasion at the same physical location (for example, if you worked at XY Plumbing in Denver, CO, during 3 separate periods of time you would enter information concerning the most recent period of employment above, and provide dates, position titles, and supervisors for the two previous periods of employment as entries below).',
      },
      employer: {
        label: 'Employer name',
        help: {
          title: 'Need help with the employer name?',
          message: 'Provide the name of your employer',
          note: '',
        },
      },
      title: {
        label: 'Title',
        help: {
          title: 'Need help with the position title?',
          message: 'Provide the name of your position title',
          note: '',
        },
      },
      status: {
        help: {
          title: 'Need help with the employment status?',
          message: 'Select the employment status',
          note: '',
        },
      },
      address: {
        label: 'This address is',
        help: {
          title: 'Acronyms:',
          message: 'APO - Army Post Office, FPO - Fleet Post Office.',
          note: '',
        },
      },
      telephone: {
        label: '',
        help: {
          title: 'Need help with the telephone number?',
          message: 'Provide the telephone number',
          note: '',
        },
      },
      physicalAddress: {
        help: {
          title: 'Are/were you working from another location?',
          message:
            'Are/were you physically working from an different location than your employer\'s address? If so answer "Yes".',
          note: '',
        },
        address: {
          label: 'This address is',
        },
        heading: {
          telephone: 'Provide telephone number',
          address: 'Provide the address of physical location',
        },
      },
      additionalActivity: {
        help: {
          title: 'Need help with additional periods of activity?',
          message: 'Do you have any additional periods of activity to add?',
          note: '',
        },
        label: 'Do you have any additional periods of activity to add?',
        collection: {
          append: 'Add additional periods',
        },
        heading: {
          position: 'Provide position title',
          supervisor: 'Provide supervisor',
          datesEmployed: 'Provide dates of employment',
        },
        position: {
          label: 'Position',
          help: {
            title: 'Need help with position title?',
            message: 'Provide the position title',
            note: '',
          },
        },
        supervisor: {
          label: 'Supervisor',
          help: {
            title: 'Need help with the supervisor name?',
            message: 'Provide the supervisor name',
            note: '',
          },
        },
        datesEmployed: {
          help: {
            title: 'Need help with the dates of employment?',
            message: 'Provide dates of employment',
            note: '',
          },
        },
      },
    },
    nongovernment: {
      heading: {
        employer: 'Provide the name of your employer',
        title: 'Provide the most recent position title',
        status: 'Select the employment status for this position',
        address: 'Provide the address of employer',
        telephone: 'Provide telephone number',
        reference: 'Provide a reference',
        physicalAddress:
          "Is/was your physical work address different than your employer's address?",
        additionalActivity: 'Additional periods of activity with this employer',
      },
      para: {
        additionalActivity:
          'Provide additional periods of activity if you worked for this employer on more than one occasion at the same physical location (for example, if you worked at XY Plumbing in Denver, CO, during 3 separate periods of time you would enter information concerning the most recent period of employment above, and provide dates, position titles, and supervisors for the two previous periods of employment as entries below).',
      },
      employer: {
        label: 'Employer name',
        help: {
          title: 'Need help with the employer name?',
          message: 'Provide the name of your employer',
          note: '',
        },
      },
      title: {
        label: 'Title',
        help: {
          title: 'Need help with the position title?',
          message: 'Provide the name of your position title',
          note: '',
        },
      },
      status: {
        help: {
          title: 'Need help with employment status?',
          message: 'Select the employment status',
          note: '',
        },
      },
      address: {
        label: 'This address is',
        help: {
          title: 'Acronyms:',
          message: 'APO - Army Post Office, FPO - Fleet Post Office.',
          note: '',
        },
      },
      telephone: {
        label: '',
        help: {
          title: 'Need help with the telephone number?',
          message: 'Provide the telephone number',
          note: '',
        },
      },
      physicalAddress: {
        help: {
          title: 'Are/were you working from another location?',
          message:
            'Are/were you physically working from an different location than your employer\'s address? If so answer "Yes".',
          note: '',
        },
        address: {
          label: 'This address is',
        },
        heading: {
          telephone: 'Provide telephone number',
          address: 'Provide the address of physical location',
        },
      },
      additionalActivity: {
        help: {
          title: 'Need help with additional periods of activity?',
          message: 'Do you have any additional periods of activity to add?',
          note: '',
        },
        label: 'Do you have any additional periods of activity to add?',
        collection: {
          append: 'Add additional periods',
        },
        heading: {
          position: 'Provide position title',
          supervisor: 'Provide supervisor',
          datesEmployed: 'Provide dates of employment',
        },
        position: {
          label: 'Position',
          help: {
            title: 'Need help with the position title?',
            message: 'Provide the position title',
            note: '',
          },
        },
        supervisor: {
          label: 'Supervisor',
          help: {
            title: 'Need help with the supervisor name?',
            message: 'Provide the supervisor name',
            note: '',
          },
        },
        datesEmployed: {
          help: {
            title: 'Need help with the dates of employment?',
            message: 'Provide dates of employment',
            note: '',
          },
        },
      },
    },
    selfemployment: {
      heading: {
        employer: 'Provide the name of your employment',
        title: 'Provide the most recent position title',
        status: 'Select the employment status for this position',
        address: 'Provide the address of employment',
        telephone: 'Provide telephone number',
        reference: 'Provide the name of someone that can verify your self-employment',
        physicalAddress: 'Is your physical work address different than your employment address?',
        militaryAddress: 'Does your self-employment verifier have an APO/FPO address?',
        additionalActivity: 'Additional periods of activity with this employer',
      },
      employer: {
        label: 'Employer name',
        help: {
          title: 'Need help with the employer name?',
          message: 'Provide the name of your employer',
          note: '',
        },
      },
      title: {
        label: 'Title',
        help: {
          title: 'Need help with the position title?',
          message: 'Provide the name of your position title',
          note: '',
        },
      },
      status: {
        help: {
          title: 'Need help with the employment status?',
          message: 'Select the employment status',
          note: '',
        },
      },
      address: {
        label: 'This address is',
        help: {
          title: 'Acronyms:',
          message: 'APO - Army Post Office, FPO - Fleet Post Office.',
          note: '',
        },
      },
      telephone: {
        label: '',
        help: {
          title: 'Need help with the telephone number?',
          message: 'Provide the telephone number',
          note: '',
        },
      },
      physicalAddress: {
        help: {
          title: 'Are/were you working from another location?',
          message:
            'Are/were you physically working from an different location than your employer\'s address? If so answer "Yes".',
          note: '',
        },
        address: {
          label: 'This address is',
        },
        heading: {
          telephone: 'Provide telephone number',
          address: 'Provide the address of physical location',
        },
      },
      additionalActivity: {
        help: {
          title: 'Need help with additional periods of activity?',
          message: 'Do you have any additional periods of activity to add?',
          note: '',
        },
        label: 'Do you have any additional periods of activity to add?',
        collection: {
          append: 'Add additional periods',
        },
        heading: {
          position: 'Provide position title',
          supervisor: 'Provide supervisor',
          datesEmployed: 'Provide dates of employment',
        },
        position: {
          label: 'Position',
          help: {
            title: 'Need help with position title?',
            message: 'Provide the position title',
            note: '',
          },
        },
        supervisor: {
          label: 'Supervisor',
          help: {
            title: 'Need help with the supervisor name?',
            message: 'Provide the supervisor name',
            note: '',
          },
        },
        datesEmployed: {
          help: {
            title: 'Need help with the dates of employment?',
            message: 'Provide dates of employment',
            note: '',
          },
        },
      },
      para: {
        additionalActivity:
          'Provide additional periods of activity if you worked for this employer on more than one occasion at the same physical location (for example, if you worked at XY Plumbing in Denver, CO, during 3 separate periods of time you would enter information concerning the most recent period of employment above, and provide dates, position titles, and supervisors for the two previous periods of employment as entries below).',
      },
    },
    unemployment: {
      heading: {
        militaryAddress: 'Does your unemployment verifier have an APO/FPO address?',
        reference:
          'Provide the name of someone who can verify your unemployment activities and means of support',
      },
    },
    other: {
      heading: {
        employer: 'Provide the name of your employer',
        title: 'Provide the most recent position title',
        status: 'Select the employment status for this position',
        address: 'Provide the address of employer',
        telephone: 'Provide telephone number',
        reference:
          'Provide the name of someone who can verify your unemployment activities and means of support',
        physicalAddress:
          "Is/was your physical work address different than your employer's address?",
        supervisorPhysicalAddress:
          'Is/was your supervisors physical work address different than your Job Location?',
        additionalActivity: 'Additional periods of activity with this employer',
      },
      activity: {
        other: {
          help: {
            title: 'Need help with employment activity?',
            message: 'Please explain the type of employment activity',
            note: '',
          },
        },
      },
      employer: {
        label: 'Employer name',
        help: {
          title: 'Need help with the employer name?',
          message: 'Provide the name of your employer',
          note: '',
        },
      },
      title: {
        label: 'Title',
        help: {
          title: 'Need help with the position title?',
          message: 'Provide the name of your position title',
          note: '',
        },
      },
      status: {
        help: {
          title: 'Need help with the employment status?',
          message: 'Select the employment status',
          note: '',
        },
        fullTime: 'Full-time',
        partTime: 'Part-time',
      },
      address: {
        label: 'This address is',
        help: {
          title: 'Acronyms:',
          message: 'APO - Army Post Office, FPO - Fleet Post Office.',
          note: '',
        },
      },
      telephone: {
        label: '',
        help: {
          title: 'Need help with the telephone number?',
          message: 'Provide the telephone number',
          note: '',
        },
      },
      physicalAddress: {
        help: {
          title: 'Are/were you working from another location?',
          message:
            'Are/were you physically working from an different location than your employer\'s address? If so answer "Yes".',
          note: '',
        },
        address: {
          label: 'This address is',
        },
        heading: {
          telephone: 'Provide telephone number',
          address: 'Provide the address of physical location',
        },
      },
      additionalActivity: {
        help: {
          title: 'Need help with any additional periods of activity?',
          message: 'Do you have any additional periods of activity to add?',
          note: '',
        },
        label: 'Do you have any additional periods of activity to add?',
        collection: {
          append: 'Add additional periods',
        },
        heading: {
          position: 'Provide position title',
          supervisor: 'Provide supervisor',
          datesEmployed: 'Provide dates of employment',
        },
        position: {
          label: 'Position',
          help: {
            title: 'Need help with the position title?',
            message: 'Provide the position title',
            note: '',
          },
        },
        supervisor: {
          label: 'Supervisor',
          help: {
            title: 'Need help with the supervisor?',
            message: 'Provide the supervisor name',
            note: '',
          },
        },
        datesEmployed: {
          help: {
            title: 'Need help with the dates of employment?',
            message: 'Provide dates of employment',
            note: '',
          },
        },
      },
      para: {
        additionalActivity:
          'Provide additional periods of activity if you worked for this employer on more than one occasion at the same physical location (for example, if you worked at XY Plumbing in Denver, CO, during 3 separate periods of time you would enter information concerning the most recent period of employment above, and provide dates, position titles, and supervisors for the two previous periods of employment as entries below).',
      },
    },
    label: {
      referenceLocationComments: 'Optional Comments',
      unemploymentComments: 'Optional Comments',
      militaryEmploymentComments: 'Optional Comments',
      nonmilitaryEmploymentComments: 'Optional Comments',
      employmentActivityComments: 'Optional Comments',
      selfEmploymentComments: 'Optional Comments',
      employmentRecordComments: 'Optional Comments',
      summaryComments: 'Optional Summary Comments',
      supervisorcomments: 'Optional Comments',
      reasonLeftAnswerComments: 'Optional Comments',
    },
  },
  education: {
    title: 'List the places you went to school',
    info:
      'Do not list education before your 18th birthday, unless to provide a minimum of two years education history.',
    infoSF852013: 'List the schools you have attended, beyond Junior High School, beginning with the most recent and working back 5 years. If all of your education occurred more than 5 years ago, list your most recent education beyond high school, no matter when that education occurred.',
    summary: {
      title: 'Where you went to school',
      schools: 'Schools attended',
      diplomas: 'Degrees/Diplomas earned',
      svgAlt: 'Years covered for schools attended',
    },
    collection: {
      caption: 'Where you went to school',
      school: {
        summary: {
          title: 'Summary of education',
          item: 'School',
          unknown: 'Provide your education details',
          incomplete: "This education's information is incomplete",
          item2: 'Diploma',
        },
        append: 'Add another school',
        appendTitle:
          'Do you have additional education to enter (include education within the last {{years}} years, as well as degrees or diplomas more than {{years}} years ago)?',
      },
      diploma: {
        summary: {
          title: 'Summary of degrees/diplomas',
          item: 'Degree',
          unknown: 'Provide your degree/diploma details',
        },
        append: 'Add another diploma/degree',
      },
    },
    heading: {
      done: "Done! Now let's add more",
      exiting: 'Before you leave this section',
      degrees: 'Degrees/diplomas',
      degree: 'Did you receive a degree/diploma?',
      degreeTail: 'Do you have another degree/diploma from this school to add?',
      details: 'Enter your school information',
      dates: 'Provide dates of attendance',
      name: 'Provide the name of the school',
      address: 'Provide the street address of the school',
      comments:
        'If you need to provide additional comments about this information enter them below',
      type: 'Select the most appropriate option to describe your school',
      reference: 'List a person who can verify that you attended this school',
      diploma: 'Provide type of degree(s)/diploma(s) received',
      date: 'Date awarded',
    },
    para: {
      exiting: '',
      reference:
        'For schools you attended in the last 3 years, list a person who knew you at the school (instructor, student, etc.). Do not list people for education periods completed more than 3 years ago. For correspondence/distance/extension/online schools, list someone who knew you while you received this education.',
    },
    label: {
      attendance: 'Have you attended any schools in the last {{years}} years?',
      degree10: 'Have you received a degree or diploma more than {{years}} years ago?',
      dates:
        'You are not required to list temporary locations of less than 90 days that did not serve as your permanent or mailing address.',
      name: 'School name',
      address: 'This address is',
      addressLink:
        'For correspondence/distance/extension/online schools, provide the address where the records are maintained. For assistance determining the school address, refer to [https://ope.ed.gov/accreditation/search](https://ope.ed.gov/accreditation/search).',
      type: {
        highschool: 'High school',
        college: 'College, university, or military college',
        vocational: 'Vocational, technical, or trade school',
        correspondence: 'Correspondence, distance, extension, or online school',
      },
      diploma: {
        received: 'Type of degree(s)/diploma(s) received',
        highschool: 'High School Diploma',
        associate: "Associate's",
        bachelor: "Bachelor's",
        master: "Master's",
        doctorate: 'Doctorate',
        professional: 'Professional Degree (eg. MD, DVM, JD)',
        other: 'Other',
        otherDiploma: 'Other degree/diploma',
      },
      comments: 'Optional Comments',
      attendedcomments: 'Optional Comments',
      diplomasanswercomments: 'Optional Comments',
      degreesawardedcomments: 'Optional Comments',
      summarycomments: 'Optional Summary Comments',
      referencecomments: 'Optional Comments',
      hasdegreecomments: 'Optional Comments',
    },
    help: {
      attendance: {
        title: 'Including all schools you attended',
        message:
          'If within the last {{years}} years you have attended a high school, college, vocational, or correspondence course answer "Yes".',
        note: '',
      },
      degree10: {
        title: 'Any degree/diploma you have received in your life',
        message: 'If you have ever earned a degree or diploma from any point in your life answer "Yes".',
        note: '',
      },
      dates: {
        title: 'Estimate the date if unsure',
        message:
          'If you are not sure of the exact dates give us your best guess and check the "Estimated" checkbox.',
        note: '',
      },
      address: {
        title:
          'For correspondence/distance/extension/online schools, provide the address where the records are maintained',
        message:
          'For assistance determining the school address, refer to [https://ope.ed.gov/accreditation/search](https://ope.ed.gov/accreditation/search).',
        note:
          'Acronyms: APO - Army Post Office, FPO - Fleet Post Office.',
      },
      type: {
        title: 'Need help with the school options?',
        message: 'Select the most appropriate option to describe your school',
        note: '',
      },
      comments: {
        title: 'Need help providing more information?',
        message:
          'If you need to provide any additional comments about this information enter them below',
        note: '',
      },
      degree: {
        title: 'Need help with a degree or diploma?',
        message:
          'If you have received one or more degrees or diplomas from this school please provide the required information',
        note: '',
      },
      diploma: {
        title: 'Select the most appropriate degree or diploma received',
        message: 'If your option isn\'t listed select "Other" then provide it.',
        note: '',
      },
      date: {
        title: 'Estimate the date if unsure',
        message:
          'If you are not sure of the exact date give us your best guess and check the "Estimated" checkbox.',
        note: '',
      },
    },
    error: {
      afterDuration: {
        title: 'There is a problem with the date',
        message: 'You indicated that you did not have any education within this education date range on a previous question.  Please check that the dates entered are correct, and adjust your response to the previous question if they are.',
      },
    }
  },
  federal: {
    agencyDropdownWarning: 'As you type the name of the agency, a list of matching agencies will appear.  Please make a selection from this list.  The agency name will be preceded by the parent agency and followed by a code for that agency, if available.  After making a selection, please ensure the agency is correct.',
    heading: {
      branch:
        'Do you have former federal civilian employment, excluding military service, NOT indicated previously, to report?',
      dates: 'Provide dates of federal civilian employment',
      name: 'Provide the name of the federal agency for which you are/were employed',
      position: 'Provide your position title',
      address: 'Provide the location of the agency',
      comments: 'Optional Comments',
    },
    comments: 'Optional Comments',
    summarycomments: 'Optional Summary Comments',
    help: {
      branch: {
        title: 'List all federal service even if older than {{years}} years',
        message: 'Inclue all former federal service at any point in your life.',
        note: '',
      },
      dates: {
        title: 'Estimate the date if unsure',
        message:
          'If you are not sure of the exact dates give us your best guess and check the "Estimated" checkbox.',
        note: '',
      },
      name: {
        title: 'Need help with the agency name?',
        message: 'The name of the federal service',
        note: '',
      },
      position: {
        title: 'Need help with the position title?',
        message: 'The most recent position title during this employment.',
        note: '',
      },
      address: {
        title: 'Try looking up the agency name, this could help you find the address',
        message:
          'Acronyms: APO - Army Post Office, FPO - Fleet Post Office.',
        note: '',
      },
    },
    collection: {
      summary: {
        title: 'Summary of former federal service',
        item: 'Federal service',
        present: 'Now',
        nodates: 'NA',
        unknown: 'Provide federal service below',
      },
      appendTitle:
        'Do you have additional former federal civilian employment, excluding military service, NOT indicated previously, to report?',
      append: 'Add another former federal service',
    },
  },
};
